export const LANGUAGES = [
  { code: "es", label: "ES", name: "Español" },
  { code: "en", label: "EN", name: "English" },
  { code: "pt", label: "PT", name: "Português" },
];

export const translations = {
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      smartlinks: "Smart Links",
      howItWorks: "Cómo funciona",
      platforms: "Plataformas",
      royalties: "Regalías",
      plans: "Planes",
      faq: "FAQ",
      contact: "Contacto",
      login: "Iniciar sesión",
      register: "Distribuye tu música",
    },
    floatingWhatsapp: {
      tooltip: "Escríbenos por WhatsApp",
    },
    cookieConsent: {
      message: "Usamos cookies para mejorar tu experiencia y analizar el uso del sitio.",
      acceptButton: "Aceptar",
      privacyLink: "Política de Privacidad",
    },
    coverArt: {
      pageTitle: "Generador de Portadas con IA",
      pageSubtitle: "Crea una portada profesional para tu próximo lanzamiento en segundos. Elige tu estilo y deja que la IA haga el resto.",
      fieldGenre: "Género / Estilo",
      fieldConcept: "Concepto Visual",
      fieldColors: "Colores Principales",
      placeholderSelect: "Selecciona una opción",
      genre: {
        romantico_sierreno: "Romántico / Sierreño",
        urbano_trap: "Urbano / Trap",
        pop_electronica: "Pop / Electrónica",
        corridos: "Corridos",
      },
      concept: {
        minimalista: "Minimalista",
        lujo_nocturno: "Lujo / Nocturno",
        vintage_acustico: "Vintage / Acústico",
        callejero: "Callejero",
        futurista: "Futurista",
      },
      colors: {
        oscuros_neon: "Tonos oscuros / neón",
        calidos_madera: "Tonos cálidos / madera",
        blanco_negro: "Blanco y negro elegante",
      },
      generateButton: "Generar portada",
      generating: "Generando tu portada… esto puede tardar hasta 1 minuto",
      errorToast: "No se pudo generar la portada. Intenta de nuevo en unos minutos.",
      rateLimitToast: "Alcanzaste el límite de generaciones por hora. Intenta más tarde.",
      resultTitle: "¡Tu portada está lista!",
      resolutionNote: "Resolución 3000×3000 px, lista para subir a Spotify, Apple Music y demás tiendas digitales.",
      downloadButton: "Descargar portada",
      regenerateButton: "Generar otra portada",
      disclaimer: "Las portadas se generan con inteligencia artificial. Revisa que cumpla con los lineamientos de tu tienda digital antes de publicarla.",
    },
    taxForms: {
      pageTitle: "Formularios fiscales del IRS",
      pageSubtitle: "Llena, firma y descarga tu W-9, W-8BEN o W-8BEN-E en minutos, sin complicaciones.",
      backToForms: "← Elegir otro formulario",
      chooseTitle: "¿Qué formulario necesitas llenar?",
      privacyNote: "Tus datos se envían de forma segura a Doble R Records para fines de cumplimiento fiscal (IRS). No compartimos esta información con terceros.",
      forms: {
        w9: {
          title: "W-9",
          subtitle: "Personas o entidades de Estados Unidos",
          useWhen: "Úsalo si eres ciudadano/residente de EE.UU. o una entidad de EE.UU. (incluye SSN o EIN).",
        },
        w8ben: {
          title: "W-8BEN",
          subtitle: "Individuos extranjeros (fuera de EE.UU.)",
          useWhen: "Úsalo si eres una persona física que NO es ciudadana ni residente fiscal de EE.UU.",
        },
        w8bene: {
          title: "W-8BEN-E",
          subtitle: "Empresas / labels extranjeras",
          useWhen: "Úsalo si tu label o empresa está constituida fuera de Estados Unidos.",
        },
      },
      sections: {
        identification: "Identificación",
        address: "Dirección",
        mailingAddress: "Dirección postal (si es diferente, opcional)",
        taxInfo: "Información fiscal",
        treaty: "Beneficios de tratado fiscal (opcional)",
        certification: "Certificación y firma",
      },
      fields: {
        name: "Nombre completo (Name)",
        orgName: "Nombre de la empresa/entidad (Name of organization)",
        businessName: "Nombre comercial / disregarded entity (opcional)",
        disregardedEntityName: "Nombre de disregarded entity (opcional)",
        taxClassification: "Clasificación fiscal federal",
        llcTaxClass: "Clasificación de la LLC (C, S o P)",
        otherDescription: "Especifica",
        chapter3Status: "Estatus de Capítulo 3 (tipo de entidad)",
        chapter4Status: "Estatus FATCA (Capítulo 4)",
        exemptPayeeCode: "Código de beneficiario exento (opcional)",
        fatcaExemptCode: "Código de exención FATCA (opcional)",
        address: "Dirección (calle y número)",
        cityStateZip: "Ciudad, estado y código postal",
        country: "País",
        mailingAddress: "Dirección postal (calle y número)",
        mailingCityStateZip: "Ciudad, estado y código postal",
        mailingCountry: "País",
        countryOfCitizenship: "País de ciudadanía",
        countryOfIncorporation: "País de incorporación",
        accountNumbers: "Número(s) de cuenta (opcional)",
        ssn: "Número de Seguro Social (SSN)",
        ein: "Número de identificación patronal (EIN)",
        usTin: "Número de identificación fiscal de EE.UU. (opcional)",
        foreignTaxId: "Número de identificación fiscal extranjero (opcional)",
        ftinNotRequired: "Mi país no exige un número de identificación fiscal (FTIN)",
        referenceNumber: "Número(s) de referencia (opcional)",
        dateOfBirth: "Fecha de nacimiento (MM-DD-AAAA)",
        treatyCountry: "País del tratado",
        treatyArticle: "Artículo del tratado",
        treatyParagraph: "Párrafo",
        treatyIncomeType: "Tipo de ingreso",
        treatyRate: "Tasa de retención (%)",
        treatyConditions: "Condiciones adicionales",
        printName: "Nombre de quien firma (Print name of signer)",
        signature: "Firma (dibuja con el mouse o el dedo)",
      },
      taxClassificationOptions: {
        individual: "Individuo / propietario único",
        c_corp: "Corporación C",
        s_corp: "Corporación S",
        partnership: "Sociedad (Partnership)",
        trust_estate: "Trust / patrimonio (estate)",
        llc: "LLC",
        other: "Otro",
      },
      chapter3Options: {
        corporation: "Corporación",
        partnership: "Sociedad (Partnership)",
        simple_trust: "Simple trust",
        tax_exempt_organization: "Organización exenta de impuestos",
        complex_trust: "Complex trust",
        foreign_gov_controlled_entity: "Entidad controlada por gobierno extranjero",
        central_bank_of_issue: "Banco central emisor",
        private_foundation: "Fundación privada",
        estate: "Patrimonio (estate)",
        foreign_gov_integral_part: "Parte integral de gobierno extranjero",
        grantor_trust: "Grantor trust",
        disregarded_entity: "Disregarded entity",
        international_organization: "Organización internacional",
      },
      chapter4Options: {
        active_nffe: "Active NFFE (entidad activa no financiera)",
        passive_nffe: "Passive NFFE (entidad pasiva no financiera)",
        other: "Otro / no estoy seguro (dejar en blanco y consultar asesor fiscal)",
      },
      chapter4Hint: "Si tu clasificación FATCA no es Active NFFE ni Passive NFFE, deja este campo sin seleccionar: te generaremos el resto del formulario y esa sección la completas con tu asesor fiscal.",
      submitButton: "Generar y descargar PDF firmado",
      submitting: "Generando PDF...",
      previewButton: "Vista previa del PDF",
      previewing: "Generando vista previa...",
      previewErrorToast: "No pudimos generar la vista previa. Revisa que los campos obligatorios estén completos.",
      successToast: "PDF generado y descargado. También lo recibimos para tu expediente.",
      errorToast: "No pudimos generar el PDF. Intenta de nuevo.",
      rateLimitToast: "Demasiados intentos. Espera unos minutos e intenta de nuevo.",
      requiredField: "Este campo es obligatorio",
      signatureHint: "Dibuja tu firma tal como la harías en papel.",
      signatureRequiredToast: "Por favor dibuja tu firma antes de enviar.",
      disclaimer: "Esta herramienta te ayuda a llenar el formulario oficial del IRS, pero no sustituye asesoría legal o fiscal profesional. Verifica siempre la información antes de enviarla.",
    },
    hero: {
      badge: "+450 plataformas · Entrega 24-48h · Video global multiplataforma",
      titleLines: ["Doble R Records", "Distribution —", "tu música merece", "llegar más lejos."],
      subtitle:
        "Gestiona tus lanzamientos, catálogo, regalías y distribución digital en más de 450 plataformas desde una infraestructura profesional. Entrega exprés en 24-48 horas y distribución de tus videos musicales a Spotify, Apple Music, TIDAL, Boomplay, XITE, YouTube y VEVO.",
      ctaRegister: "Distribuye tu música",
      ctaLogin: "Iniciar sesión",
      catalogTitle: "Mi catálogo",
      catalogSubtitle: "Panel privado",
      items: [
        { name: "Bajo la Luna", type: "Sencillo", status: "Live" },
        { name: "Fuego Nuevo", type: "Nuevo sencillo", status: "Entregado" },
        { name: "Horizontes", type: "EP", status: "En revisión" },
        { name: "Raíces Vol. II", type: "Álbum", status: "Programado" },
      ],
      badgesByItem: [["UPC 8909213", "Regalías: $1,204"], ["Splits 60/40"], ["4 tracks"], ["Lanza en 12 días"]],
      statFundLabel: "fondo artista",
      statPlatformsLabel: "plataformas",
      stats: [
        { id: "platforms", to: 450, suffix: "+", label: "Plataformas digitales" },
        { id: "delivery", to: 48, prefix: "24-", suffix: "h", label: "Entrega exprés" },
        { id: "commission", to: 10, suffix: "%", label: "Comisión Doble R" },
      ],
    },
    communityStats: {
      items: [
        { id: "artists", to: 1, suffix: "K+", label: "Artistas" },
        { id: "tracks", to: 50, suffix: "K+", label: "Canciones" },
        { id: "paidout", to: 1, prefix: "$", suffix: "M+", label: "Pagado a artistas" },
        { id: "countries", to: 195, suffix: "+", label: "Países" },
      ],
    },
    requestStatus: {
      pageTitle: "Consulta el Estado de tu Solicitud",
      pageSubtitle: "Ingresa el código único que recibiste al enviar tu solicitud de distribución.",
      inputLabel: "Código de solicitud",
      inputPlaceholder: "Ej. 090626SOL-020",
      submitButton: "Consultar",
      notFoundError: "No encontramos ninguna solicitud con ese código. Verifica que esté escrito correctamente.",
      genericError: "Ocurrió un error al consultar tu solicitud. Intenta de nuevo.",
      rateLimitError: "Demasiados intentos. Intenta de nuevo en un momento.",
      resultArtistLabel: "Artista / Sello",
      resultSubmittedLabel: "Enviada el",
      statusUnderReview: "En revisión",
      statusSigned: "Acuerdo firmado",
      signedInfo: "Firmaste tu acuerdo de distribución el",
      underReviewInfo: "Tu solicitud está en revisión. Te contactaremos por correo si necesitamos algo más.",
      searchAnotherButton: "Consultar otro código",
    },
    marquee: {
      label: "Distribución global",
      title: "Tu música en más de 450 plataformas digitales globales",
      disclaimer:
        "Todas las marcas, logotipos y nombres de plataformas mostrados son propiedad de sus respectivos dueños y se utilizan únicamente con fines informativos. La disponibilidad de distribución puede variar según el territorio y la plataforma.",
      more: "+450 tiendas más",
    },
    platformsCatalog: {
      label: "Plataformas destacadas",
      title: "Las tiendas que mueven la industria.",
      items: [
        { name: "Spotify", desc: "El mayor motor de descubrimiento musical del mundo, con playlists editoriales y algoritmos de recomendación.", tag: "Canvas & playlists editoriales" },
        { name: "Apple Music", desc: "Audio en calidad Lossless y Spatial Audio dentro de todo el ecosistema Apple.", tag: "Lossless & Spatial Audio" },
        { name: "YouTube Music", desc: "Monetiza tus videos oficiales con Content ID, sincronizado con tu distribución de audio.", tag: "Content ID & monetización" },
        { name: "TikTok", desc: "Convierte tu canción en sonido viral dentro de la librería de sonidos para creadores.", tag: "Sonidos virales" },
        { name: "Amazon Music", desc: "Streaming y compra digital dentro del ecosistema Amazon, incluyendo dispositivos Alexa.", tag: "Alexa & streaming HD" },
        { name: "Deezer", desc: "Alcance editorial en Europa y Latinoamérica con Flow, su algoritmo de recomendación.", tag: "Algoritmo Flow" },
      ],
      moreLabel: "Y mucho más",
    },
    smartlink: {
      chooseService: "Elige tu plataforma preferida",
      preRelease: "Próximo lanzamiento",
      released: "Ya disponible",
      availableOn: "Disponible el",
      preSave: "Pre-guardar",
      preAdd: "Pre-añadir",
      listenNow: "Escuchar",
      comingSoon: "Disponible próximamente en esta plataforma",
      poweredBy: "Distribuido por",
      notFoundTitle: "Este enlace no existe",
      notFoundSubtitle: "Revisa el link o vuelve al inicio.",
      backHome: "Volver al inicio",
      followArtist: "Sigue a",
      recommended: "Recomendado para tu dispositivo",
      namePlaceholder: "Tu nombre",
      emailPlaceholder: "Tu correo electrónico",
      formSubmit: "Quiero enterarme",
      formSuccess: "¡Gracias! Te avisaremos de las novedades.",
      formError: "Completa todos los campos correctamente.",
      privacyNote: "Respetamos tu privacidad. No compartimos tus datos con terceros.",
      manageModeHint: "Modo de gestión: solo tú puedes ver este botón.",
      refreshLinksButton: "Actualizar enlaces",
      refreshingLinks: "Buscando actualizaciones...",
      refreshNewLinksFound: "¡Encontramos nuevos enlaces!",
      refreshNoNewLinks: "Sin novedades por ahora. Intenta de nuevo el día del lanzamiento.",
      refreshError: "No se pudo actualizar. Intenta de nuevo en un momento.",
      noPlatformsYet: "Aún no hay plataformas disponibles para este lanzamiento. Déjanos tu correo y te avisamos en cuanto estén listas →",
    },    createSmartlink: {
      pageTitle: "Crea tu Smartlink",
      pageSubtitle: "Genera una página de pre-save para tu lanzamiento en segundos. Solo necesitas el código UPC de tu música.",
      upcLabel: "Código UPC",
      upcPlaceholder: "Ej. 024543757917",
      lookupButton: "Buscar datos",
      lookupFound: "Encontramos los datos de tu lanzamiento.",
      lookupNotFound: "No encontramos datos para ese UPC. Completa los campos manualmente.",
      lookupError: "No se pudo consultar el UPC. Intenta de nuevo.",
      titleLabel: "Título de la canción",
      artistLabel: "Nombre del artista",
      coverLabel: "URL de la portada",
      releaseDateLabel: "Fecha de lanzamiento",
      statusLabel: "Estado",
      statusPreRelease: "Próximo lanzamiento",
      statusReleased: "Ya disponible",
      platformLinksLabel: "Enlaces a plataformas (opcional)",
      platformLinksHint: "Agrega el link si ya está disponible en esa tienda. Puedes dejarlo vacío y agregarlo después.",
      socialLinksLabel: "Redes sociales (opcional)",
      artistNoteLabel: "Nota del artista (opcional)",
      artistNotePlaceholder: "Un mensaje personal o la letra de la canción",
      submitButton: "Crear mi Smartlink",
      submitting: "Creando...",
      rateLimitError: "Demasiados intentos. Espera unos minutos e intenta de nuevo.",
      genericError: "No se pudo crear el smartlink. Verifica tus datos e intenta de nuevo.",
      requiredFieldsError: "Completa el UPC, título, artista y portada para continuar.",
      minPlatformsWarning: "Recomendamos al menos 5 plataformas activas con enlace directo. Ahora mismo tienes {count}. Agrega más manualmente para una mejor experiencia de tus fans.",
      successTitle: "¡Tu Smartlink está listo!",
      successSubtitle: "Compártelo con tus fans en redes sociales.",
      yourLinkLabel: "Tu enlace",
      copyButton: "Copiar",
      copiedLabel: "¡Copiado!",
      viewButton: "Ver mi Smartlink",
      createAnotherButton: "Crear otro Smartlink",
      manageLinkLabel: "Enlace de gestión (guárdalo en privado)",
      manageLinkHint: "Vuelve aquí el día del lanzamiento para buscar automáticamente nuevos enlaces (Spotify, Tidal, etc). No lo compartas con tus fans.",
      copyManageButton: "Copiar",
    },
    globalReach: {
      label: "Alcance global",
      title: "Presencia en más de 195 países.",
      subtitle: "Desde América hasta Asia-Pacífico, tu música llega a los mercados digitales que más importan, en las plataformas líderes de cada región.",
      regions: [
        { flag: "🌎", name: "Norteamérica", desc: "El mercado discográfico más grande del mundo, con streaming premium y catálogo de alto valor.", platforms: "Spotify · Apple Music · Amazon Music" },
        { flag: "🌎", name: "Latinoamérica", desc: "Reggaetón, corridos y música urbana lideran el consumo digital de la región.", platforms: "YouTube Music · Spotify · Deezer" },
        { flag: "🌍", name: "Europa", desc: "Mercado editorial fuerte, con streaming premium y alto valor de catálogo.", platforms: "Spotify · Deezer · Apple Music" },
        { flag: "🌍", name: "África & Medio Oriente", desc: "Crecimiento acelerado impulsado por streaming móvil y redes sociales.", platforms: "Boomplay · Audiomack · Anghami" },
        { flag: "🌏", name: "Asia-Pacífico", desc: "Ecosistemas propios y consumo móvil masivo en mercados de altísimo volumen.", platforms: "LINE Music · KKBOX · YouTube Music" },
      ],
    },
    services: {
      chapterLabel: "Capítulo 01 — Qué hacemos",
      titleLines: ["Todo lo que tu música necesita,", "en un solo lugar."],
      items: {
        distribucion: { title: "Distribución digital masiva", desc: "Entrega tu música a más de 450 plataformas digitales en 24-48 horas." },
        vevo: { title: "Videos en Spotify, Apple Music y más", desc: "Distribuye tus videos musicales oficiales a Spotify, Apple Music, TIDAL, Boomplay, XITE, YouTube y VEVO." },
        catalogo: { title: "Gestión de catálogo centralizada", desc: "Todos tus lanzamientos, en un solo panel privado." },
        revision: { title: "Revisión profesional de lanzamientos", desc: "Equipo especializado revisa cada entrega antes de salir al mercado." },
        metadata: { title: "Administración de metadata completa", desc: "Créditos, géneros e idiomas correctamente estructurados." },
        "upc-isrc": { title: "UPC e ISRC", desc: "Asignación de identificadores estándar de la industria." },
        "regalias-tiempo-real": { title: "Regalías en tiempo real", desc: "Control total de tus ingresos por plataforma y territorio." },
        splits: { title: "Splits con precisión decimal", desc: "Reparto exacto entre colaboradores, sin errores de redondeo." },
        statements: { title: "Statements descargables", desc: "Balances por periodo, listos para exportar." },
        presave: { title: "Pre-save integrado", desc: "Campañas de pre-guardado listas para tu próximo lanzamiento." },
        soporte: { title: "Soporte humano especializado", desc: "Un equipo real, para artistas y labels, cuando lo necesites." },
      },
    },
    process: {
      chapterLabel: "Capítulo 02 — El proceso",
      title: "Cómo funciona.",
      steps: [
        { number: "01", title: "Crea tu cuenta", desc: "Regístrate como artista, label o representante en minutos." },
        { number: "02", title: "Sube tu lanzamiento", desc: "Portada JPG 3000x3000px, audios en WAV/FLAC, metadata y splits." },
        { number: "03", title: "Revisión profesional", desc: "Aprobación rápida, verificación de UPC/ISRC y salida en 24-48 hrs a +450 tiendas." },
        { number: "04", title: "Gestiona tu catálogo", desc: "Consulta balances, regalías y descargas desde tu panel privado." },
      ],
    },
    royalty: {
      chapterLabel: "Capítulo 03 — Transparencia",
      title: "Regalías claras y organizadas.",
      badgePart1: "10% Doble R Records",
      badgePart2: "90% fondo del artista",
      paragraph:
        "El 100% del fondo asignado a tu lanzamiento se reparte entre los splits definidos por artista o label, con historial completo de retiros y balances por periodo, siempre disponibles en tu panel privado.",
      chartLabel90: "Fondo Artista / Label",
      calculatorLabel: "Simulador de regalías",
      calculatorRevenueLabel: "Ingresos mensuales estimados",
      calculatorArtistLabel: "Tu parte (90%)",
      calculatorDobleRLabel: "Doble R Records (10%)",
      sideCards: [
        { title: "Splits decimales", desc: "Reparto exacto entre colaboradores, sin errores de redondeo." },
        { title: "Historial de retiros", desc: "Consulta cada balance liquidado, ordenado por periodo." },
        { title: "Balances por periodo", desc: "Statements descargables listos para exportar cuando quieras." },
      ],
    },
    plans: {
      chapterLabel: "Capítulo 04 — Elige tu plan",
      title: "Un plan para cada etapa de tu carrera.",
      subtitle: "Empieza gratis o desbloquea un mayor porcentaje para ti con una suscripción mensual o anual.",
      toggleMonthly: "Mensual",
      toggleAnnual: "Anual",
      annualDiscountBadge: "Ahorra ~25%",
      annualSuffix: "/año",
      ctaButton: "Elegir plan",
      mostPopularBadge: "Más elegido",
      forYouLabel: "para ti",
      items: [
        {
          name: "Free",
          priceMonthly: "$0",
          priceAnnual: "$0",
          priceSuffix: "/mes",
          artistShare: "90%",
          dobleRShare: "10%",
          desc: "Empieza a distribuir sin costo inicial. Doble R Records retiene una comisión sobre tus regalías.",
          features: ["Distribución a más de 450 plataformas", "90% del fondo para ti, 10% para Doble R Records", "Entrega exprés en 24-48 horas", "Panel de regalías y splits incluido"],
        },
        {
          name: "Premium",
          priceMonthly: "$9.99",
          priceAnnual: "$89",
          priceSuffix: "/mes",
          artistShare: "95%",
          dobleRShare: "5%",
          desc: "Reduce la comisión de Doble R Records al 5% con una suscripción fija.",
          features: ["Todo lo incluido en Free", "95% del fondo para ti, 5% para Doble R Records", "Soporte prioritario", "Revisión acelerada de lanzamientos"],
        },
        {
          name: "Premium Plus",
          priceMonthly: "$19.99",
          priceAnnual: "$179",
          priceSuffix: "/mes",
          artistShare: "100%",
          dobleRShare: "0%",
          desc: "Quédate con el 100% de tus regalías. Sin comisión, solo tu suscripción fija.",
          features: ["Todo lo incluido en Premium", "100% del fondo para ti, 0% de comisión", "Gerente de cuenta dedicado", "Pitch prioritario a playlists editoriales"],
        },
      ],
      disclaimer: "* Precios de referencia, sujetos a confirmación final antes del lanzamiento de los planes de pago.",
    },
    subscribeDialog: {
      title: "Suscríbete a",
      description: "Ingresa tus datos para continuar al pago seguro con Stripe.",
      nameLabel: "Tu nombre",
      namePlaceholder: "Nombre completo",
      emailLabel: "Correo electrónico",
      emailPlaceholder: "tu@email.com",
      submitButton: "Continuar al pago",
      loadingText: "Redirigiendo a Stripe...",
      errorMessage: "No se pudo iniciar el pago. Intenta de nuevo.",
    },
    paymentSuccess: {
      title: "¡Pago confirmado!",
      subtitle: "Tu suscripción está activa. Bienvenido a un mayor porcentaje de regalías.",
      planLabel: "Plan activado",
      pendingTitle: "Confirmando tu pago...",
      pendingSubtitle: "Esto puede tardar unos segundos.",
      errorTitle: "No pudimos confirmar el pago",
      errorSubtitle: "Si el cargo se realizó, contáctanos y lo resolvemos.",
      backHomeButton: "Volver al inicio",
    },
    paymentCancelled: {
      title: "Pago cancelado",
      subtitle: "No se realizó ningún cargo. Puedes intentarlo de nuevo cuando quieras.",
      backButton: "Ver planes de nuevo",
    },
    comparison: {
      chapterLabel: "Capítulo 05 — Por qué elegirnos",
      title: "Compara y decide con datos, no con promesas.",
      subtitle: "Así nos comparamos frente a las 10 distribuidoras más conocidas del mercado.",
      ourBadge: "Recomendado",
      scrollHint: "Desliza para ver los demás",
      rowLabels: {
        commission: "Comisión que retienen",
        costModel: "Modelo de costo",
        platformReach: "Plataformas y tiendas digitales",
        delivery: "Tiempo de entrega",
        contentId: "Video en YouTube (Content ID) y VEVO sin costo extra",
        noLockIn: "Solicita tu baja o takedown cuando quieras",
        spanishFirst: "Soporte y panel 100% en español",
      },
      priceLabels: {
        priceFree: "Sin costo de entrada",
        priceAnnual: "Suscripción anual",
        pricePerRelease: "Pago por lanzamiento",
        priceFreemium: "Gratis o plan pago",
        priceSelective: "Acceso por invitación",
      },
      cellLabels: {
        varies: "Variable",
        addon: "Extra de pago",
        partial: "Parcial",
        yes: "Sí",
        no: "No",
      },
      footnote: "*Algunos proveedores cobran suscripción anual fija además de (o en lugar de) comisión; revisa siempre los términos vigentes en el sitio oficial de cada distribuidora. SoundOn no cobra al iniciar y retiene 100% de regalías el primer año, pero a partir del mes 13 aplica 10% en plataformas como Spotify/Apple Music (100% se mantiene en TikTok/Resso), y cambiar de distribuidor implica perder esa tarifa preferencial. Comparativa elaborada con información pública disponible en 2026 y sujeta a cambios por parte de cada proveedor.",
    },
    paraQuien: {
      label: "Para quién",
      title: "Hecho para artistas y para labels.",
      tabArtists: "Artistas",
      tabLabels: "Labels / Representantes",
      captionArtists: "Tu música, tu control.",
      captionLabels: "Escala tu catálogo.",
      toolsArtists: [
        "Panel de catálogo personal con estado en tiempo real",
        "Solicitudes de Pre-save para cada lanzamiento",
        "Retiros y balances por periodo, siempre visibles",
        "Splits directos con productores y colaboradores",
        "Soporte dedicado para dudas de lanzamiento",
      ],
      toolsLabels: [
        "Gestión multi-artista desde un solo panel centralizado",
        "Reportes consolidados de regalías por artista y release",
        "Administración de metadata y derechos a escala",
        "Roles y accesos para managers y representantes",
        "Prioridad de revisión para catálogos grandes",
      ],
    },
    security: {
      label: "Seguridad y beneficios",
      title: "Infraestructura de nivel bancario.",
      subtitle:
        "Cada envío pasa por validaciones estrictas y límites de tasa contra abuso, con acceso administrativo protegido por autenticación — tus datos financieros y de identidad nunca quedan expuestos.",
      statusLabel: "Activo",
      points: [
        { title: "Acceso administrativo protegido", desc: "El panel de administración solo es accesible con autenticación segura; ningún dato de artistas es visible sin sesión verificada." },
        { title: "Archivos protegidos", desc: "Tu música y portadas se almacenan bajo protocolos de acceso restringido." },
        { title: "Encriptación SSL", desc: "Toda la comunicación con el portal viaja cifrada de extremo a extremo." },
        { title: "Datos bancarios restringidos", desc: "La información financiera se maneja bajo acceso limitado y segmentado." },
        { title: "Auditoría interna", desc: "Revisiones periódicas de seguridad sobre procesos e infraestructura." },
        { title: "Monitoreo continuo", desc: "Vigilancia activa 24/7 sobre el portal de distribución." },
      ],
    },
    faq: {
      label: "Preguntas frecuentes",
      title: "Todo lo que necesitas saber.",
      items: [
        { q: "¿Cómo me registro en Doble R Records Distribution?", a: "Completa el formulario de registro con tu nombre, correo, nombre de artista o label y el tipo de cuenta que deseas solicitar. Al finalizar serás dirigido al portal oficial para activar tu cuenta." },
        { q: "¿En verdad distribuyen a más de 450 plataformas?", a: "Sí. Tu música y videos llegan a Spotify, Apple Music, YouTube Music, Amazon Music, TikTok, Deezer, Tidal y más de 450 tiendas y plataformas digitales alrededor del mundo, sujeto a disponibilidad por territorio." },
        { q: "¿Qué formatos de audio aceptan?", a: "Aceptamos archivos de audio en alta calidad WAV o FLAC para garantizar la mejor fidelidad posible en cada plataforma." },
        { q: "¿Qué requisitos debe cumplir mi portada?", a: "Las portadas deben entregarse en formato JPG con una resolución mínima de 3000x3000px, sin logos de plataformas ni información de contacto." },
        { q: "¿Cuánto cobran de comisión?", a: "Nuestra comisión es del 10% sobre lo generado. El 90% restante del fondo pertenece íntegramente al artista o label, con reparto de splits transparente." },
        { q: "¿Cuánto tarda en salir mi música?", a: "Una vez aprobado tu lanzamiento, la entrega a más de 450 plataformas se realiza en un lapso de 24 a 48 horas." },
        { q: "¿Cómo funciona la distribución de mis videos musicales?", a: "Distribuimos tus videos musicales oficiales a Spotify, Apple Music, TIDAL, Boomplay, XITE, YouTube y VEVO, con el mismo estándar profesional que usan las majors." },
        { q: "¿Dónde accedo a mi cuenta una vez registrado?", a: "Todo el acceso, gestión de catálogo y regalías se realiza desde el portal oficial en distro.doblerrecords.com." },
      ],
    },
    testimonials: {
      label: "Casos de éxito",
      title: "Lo que dicen los artistas y labels.",
      items: [
        { name: "Barrio Fino", role: "Label", quote: "Doble R Records nos dio la claridad y velocidad que necesitábamos. Sus reportes de regalías son 100% transparentes, la entrega a plataformas digitales es impecable y el soporte es directo. Ha sido el socio clave para hacer crecer el catálogo de Barrio Fino con total confianza." },
        { name: "Alto Impacto Records", role: "Label", quote: "Migrar nuestro catálogo a Doble R Records cambió el juego. La velocidad de ingesta a plataformas digitales, el soporte con el Content ID y la puntualidad en los pagos nos dieron el respaldo exacto que necesitábamos para escalar." },
        { name: "Javier \"Javi\" Morales", role: "Representante", quote: "Encontrar una distribuidora que realmente responda a las necesidades de los artistas no es fácil. Con Doble R Records tenemos transparencia en regalías, rapidez en los estrenos y un soporte técnico impecable. Nos dan la tranquilidad para enfocarnos al 100% en la carrera de nuestro roster." },
      ],
      ctaText: "¿Ya trabajas con nosotros?",
      ctaButton: "Comparte tu experiencia",
      formTitle: "Comparte tu experiencia",
      formDescription: "Tu opinión se publica de inmediato en esta sección.",
      fieldName: "Nombre",
      fieldRole: "Rol o label/artista",
      fieldQuote: "Tu opinión",
      placeholderName: "Tu nombre",
      placeholderRole: "Ej. Label, Artista, Representante",
      placeholderQuote: "Cuéntanos tu experiencia con Doble R Records...",
      submitButton: "Publicar opinión",
      submitting: "Publicando...",
      successMessage: "¡Gracias! Tu opinión ya está publicada.",
      errorMessage: "No se pudo publicar tu opinión. Intenta de nuevo.",
      rateLimitMessage: "Has enviado demasiadas opiniones. Intenta más tarde.",
      validationMessage: "Completa todos los campos (opinión mínimo 20 caracteres).",
      countLabel: "testimonios verificados",
    },
    footer: {
      ctaHeading: "Empieza a gestionar tu música profesionalmente.",
      navLabel: "Navegación",
      legalLabel: "Centro legal",
      legalLinks: ["Términos y Condiciones", "Política de Privacidad", "Aviso de Copyright", "Política de Streaming Artificial"],
      taxFormsLink: "Formularios fiscales (W-9 / W-8BEN)",
      coverArtLink: "Generador de portadas (IA)",
      requestStatusLink: "Consultar estado de solicitud",
      contactLabel: "Contacto",
      tagline: "Distribución digital global para artistas, labels y representantes. 90% del fondo para ti, siempre.",
      copyright: "Copyright © 2026 Doble R Records. Todos los derechos reservados.",
      staticNote: "Arquitectura estática · Sin bases de datos expuestas",
    },
    modal: {
      title: "Distribuye tu música",
      description: "Completa tus datos y te dirigiremos al portal oficial para activar tu cuenta.",
      fieldName: "Nombre completo",
      fieldEmail: "Correo electrónico",
      fieldPhone: "Número de teléfono",
      fieldLabel: "Nombre del Artista o Sello",
      fieldAccountType: "Tipo de cuenta a solicitar",
      fieldCatalogSize: "Tamaño de tu catálogo actual",
      fieldReleaseFrequency: "Frecuencia de lanzamientos",
      fieldExperience: "Experiencia previa en distribución",
      fieldGoals: "Tus objetivos con Doble R Records",
      fieldSocialLinks: "Enlaces a redes sociales y plataformas de streaming",
      sectionContact: "Información de contacto",
      sectionArtist: "Información del artista o sello",
      sectionCatalog: "Datos de lanzamiento y catálogo",
      sectionExperience: "Experiencia y objetivos",
      sectionLinks: "Enlaces y redes",
      placeholderName: "Tu nombre completo",
      placeholderEmail: "tu@correo.com",
      placeholderPhone: "+52 55 1234 5678",
      placeholderLabel: "Nombre de tu artista o sello",
      placeholderCatalogSize: "Ej. 20 canciones, 3 álbumes",
      placeholderReleaseFrequency: "Selecciona una frecuencia",
      placeholderExperience: "Cuéntanos brevemente tu experiencia distribuyendo música",
      placeholderGoals: "¿Qué quieres lograr con Doble R Records Distribution?",
      placeholderSocialLinks: "Spotify, Apple Music, YouTube, Instagram...",
      placeholderSelect: "Selecciona una opción",
      optionArtist: "Artista",
      optionLabel: "Label",
      optionManager: "Representante / Manager",
      releaseFrequencyMonthly: "Mensual",
      releaseFrequencyWeekly: "Semanal",
      releaseFrequencyQuarterly: "Trimestral",
      releaseFrequencyOther: "Otra",
      accountTypeError: "Selecciona un tipo de cuenta para continuar.",
      releaseFrequencyError: "Selecciona una frecuencia de lanzamientos para continuar.",
      submitButton: "Continuar al portal",
      footnote: "Al continuar serás redirigido a distro.doblerrecords.com para completar tu registro de forma segura.",
      requestSubmitError: "No se pudo enviar tu solicitud. Verifica tus datos e inténtalo de nuevo.",
      underReviewTitle: "Solicitud en revisión",
      underReviewSubmittedOn: "Enviado el",
      underReviewMessage: "¡Gracias por enviar tu solicitud! Nuestro equipo revisará tu información y se pondrá en contacto por correo electrónico una vez que se haya tomado una decisión.",
      underReviewLockedNote: "Esta solicitud no se puede modificar una vez enviada.",
      underReviewContinueButton: "Continuar y firmar el acuerdo",
      yourCodeLabel: "Tu código de solicitud",
      yourCodeHint: "Guárdalo para consultar el estado de tu solicitud en cualquier momento en /consultar-solicitud",
      copyButton: "Copiar",
      copiedLabel: "¡Copiado!",
      successTitle: "¡Solicitud recibida!",
      successDesc: "Te estamos redirigiendo al portal oficial para activar tu cuenta…",
      spamNote: "Nuestro equipo revisará tu solicitud y se pondrá en contacto contigo si necesita algo más. Ya puedes continuar al portal para activar tu cuenta.",
      continueButton: "Continuar",
      backButton: "Atrás",
      agreementTitle: "Acuerdo de Licencia y Distribución Digital",
      agreementIntro: "Antes de continuar, revisa y acepta el acuerdo de licencia y distribución digital.",
      keyPointsTitle: "Lo que debes saber de nuestro acuerdo:",
      keyPointOwnership: "**100% Dueño de tu Música:** Mantienes la propiedad total de tu máster y composición. Nosotros solo somos un puente hacia las tiendas.",
      keyPointCommission: "**Comisión del 10%:** Esquema transparente. Tú conservas el 90% de todas las regalías que generes; nosotros retenemos el 10% por la distribución y herramientas.",
      keyPointNoLockIn: "**Sin Plazos Forzosos:** Eres libre. Puedes solicitar la baja (takedown) de tu catálogo en cualquier momento sin penalizaciones.",
      scrollHint: "Desplázate hasta el final para poder aceptar el acuerdo.",
      checkboxLabel: "He leído y acepto el Acuerdo de Licencia y Distribución Digital",
      acceptButton: "Acepto acuerdo de distribución",
      sending: "Enviando…",
      submitError: "No se pudo procesar tu solicitud. Verifica tus datos e inténtalo de nuevo en unos minutos.",
      rateLimitError: "Demasiados intentos desde este dispositivo. Espera unos minutos antes de volver a intentarlo.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      smartlinks: "Smart Links",
      howItWorks: "How it works",
      platforms: "Platforms",
      royalties: "Royalties",
      plans: "Plans",
      faq: "FAQ",
      contact: "Contact",
      login: "Log in",
      register: "Distribute your music",
    },
    floatingWhatsapp: {
      tooltip: "Chat with us on WhatsApp",
    },
    cookieConsent: {
      message: "We use cookies to improve your experience and analyze site usage.",
      acceptButton: "Accept",
      privacyLink: "Privacy Policy",
    },
    coverArt: {
      pageTitle: "AI Album Cover Generator",
      pageSubtitle: "Create a professional cover for your next release in seconds. Pick your style and let the AI do the rest.",
      fieldGenre: "Genre / Style",
      fieldConcept: "Visual Concept",
      fieldColors: "Main Colors",
      placeholderSelect: "Select an option",
      genre: {
        romantico_sierreno: "Romantic / Sierreño",
        urbano_trap: "Urban / Trap",
        pop_electronica: "Pop / Electronic",
        corridos: "Corridos",
      },
      concept: {
        minimalista: "Minimalist",
        lujo_nocturno: "Luxury / Nightlife",
        vintage_acustico: "Vintage / Acoustic",
        callejero: "Street",
        futurista: "Futuristic",
      },
      colors: {
        oscuros_neon: "Dark tones / neon",
        calidos_madera: "Warm tones / wood",
        blanco_negro: "Elegant black and white",
      },
      generateButton: "Generate cover",
      generating: "Generating your cover… this can take up to 1 minute",
      errorToast: "We couldn't generate the cover. Please try again in a few minutes.",
      rateLimitToast: "You reached the hourly generation limit. Please try again later.",
      resultTitle: "Your cover is ready!",
      resolutionNote: "3000×3000 px resolution, ready to upload to Spotify, Apple Music and other digital stores.",
      downloadButton: "Download cover",
      regenerateButton: "Generate another cover",
      disclaimer: "Covers are generated with artificial intelligence. Check that it meets your digital store's guidelines before publishing.",
    },
    taxForms: {
      pageTitle: "IRS Tax Forms",
      pageSubtitle: "Fill out, sign and download your W-9, W-8BEN or W-8BEN-E in minutes, hassle-free.",
      backToForms: "← Choose another form",
      chooseTitle: "Which form do you need to fill out?",
      privacyNote: "Your data is sent securely to Doble R Records for IRS tax compliance purposes. We never share this information with third parties.",
      forms: {
        w9: {
          title: "W-9",
          subtitle: "U.S. persons or entities",
          useWhen: "Use this if you are a U.S. citizen/resident or a U.S. entity (includes SSN or EIN).",
        },
        w8ben: {
          title: "W-8BEN",
          subtitle: "Foreign individuals (outside the U.S.)",
          useWhen: "Use this if you are an individual who is NOT a U.S. citizen or tax resident.",
        },
        w8bene: {
          title: "W-8BEN-E",
          subtitle: "Foreign companies / labels",
          useWhen: "Use this if your label or company is incorporated outside the United States.",
        },
      },
      sections: {
        identification: "Identification",
        address: "Address",
        mailingAddress: "Mailing address (if different, optional)",
        taxInfo: "Tax information",
        treaty: "Tax treaty benefits (optional)",
        certification: "Certification & signature",
      },
      fields: {
        name: "Full name (Name)",
        orgName: "Name of organization",
        businessName: "Business name / disregarded entity (optional)",
        disregardedEntityName: "Disregarded entity name (optional)",
        taxClassification: "Federal tax classification",
        llcTaxClass: "LLC tax classification (C, S or P)",
        otherDescription: "Specify",
        chapter3Status: "Chapter 3 status (entity type)",
        chapter4Status: "FATCA status (Chapter 4)",
        exemptPayeeCode: "Exempt payee code (optional)",
        fatcaExemptCode: "FATCA exemption code (optional)",
        address: "Address (street and number)",
        cityStateZip: "City, state and ZIP code",
        country: "Country",
        mailingAddress: "Mailing address (street and number)",
        mailingCityStateZip: "City, state and ZIP code",
        mailingCountry: "Country",
        countryOfCitizenship: "Country of citizenship",
        countryOfIncorporation: "Country of incorporation",
        accountNumbers: "Account number(s) (optional)",
        ssn: "Social Security Number (SSN)",
        ein: "Employer Identification Number (EIN)",
        usTin: "U.S. taxpayer identification number (optional)",
        foreignTaxId: "Foreign tax identifying number (optional)",
        ftinNotRequired: "My country does not require a foreign tax ID (FTIN)",
        referenceNumber: "Reference number(s) (optional)",
        dateOfBirth: "Date of birth (MM-DD-YYYY)",
        treatyCountry: "Treaty country",
        treatyArticle: "Treaty article",
        treatyParagraph: "Paragraph",
        treatyIncomeType: "Type of income",
        treatyRate: "Withholding rate (%)",
        treatyConditions: "Additional conditions",
        printName: "Print name of signer",
        signature: "Signature (draw with mouse or finger)",
      },
      taxClassificationOptions: {
        individual: "Individual / sole proprietor",
        c_corp: "C Corporation",
        s_corp: "S Corporation",
        partnership: "Partnership",
        trust_estate: "Trust / estate",
        llc: "LLC",
        other: "Other",
      },
      chapter3Options: {
        corporation: "Corporation",
        partnership: "Partnership",
        simple_trust: "Simple trust",
        tax_exempt_organization: "Tax-exempt organization",
        complex_trust: "Complex trust",
        foreign_gov_controlled_entity: "Foreign Government-Controlled Entity",
        central_bank_of_issue: "Central Bank of Issue",
        private_foundation: "Private foundation",
        estate: "Estate",
        foreign_gov_integral_part: "Foreign Government-Integral Part",
        grantor_trust: "Grantor trust",
        disregarded_entity: "Disregarded entity",
        international_organization: "International organization",
      },
      chapter4Options: {
        active_nffe: "Active NFFE",
        passive_nffe: "Passive NFFE",
        other: "Other / not sure (leave blank and consult a tax advisor)",
      },
      chapter4Hint: "If your FATCA classification is not Active NFFE or Passive NFFE, leave this unselected: we'll generate the rest of the form and you complete that section with your tax advisor.",
      submitButton: "Generate & download signed PDF",
      submitting: "Generating PDF...",
      previewButton: "Preview PDF",
      previewing: "Generating preview...",
      previewErrorToast: "We couldn't generate the preview. Check that required fields are filled in.",
      successToast: "PDF generated and downloaded. We also received a copy for your file.",
      errorToast: "We couldn't generate the PDF. Please try again.",
      rateLimitToast: "Too many attempts. Wait a few minutes and try again.",
      requiredField: "This field is required",
      signatureHint: "Draw your signature as you would on paper.",
      signatureRequiredToast: "Please draw your signature before submitting.",
      disclaimer: "This tool helps you fill out the official IRS form, but it does not replace professional legal or tax advice. Always verify the information before submitting.",
    },
    hero: {
      badge: "+450 platforms · 24-48h delivery · Multi-platform video distribution",
      titleLines: ["Doble R Records", "Distribution —", "your music deserves", "to go further."],
      subtitle:
        "Manage your releases, catalog, royalties and digital distribution across more than 450 platforms from a professional infrastructure. Express delivery in 24-48 hours and distribution of your music videos to Spotify, Apple Music, TIDAL, Boomplay, XITE, YouTube and VEVO.",
      ctaRegister: "Distribute your music",
      ctaLogin: "Log in",
      catalogTitle: "My catalog",
      catalogSubtitle: "Private panel",
      items: [
        { name: "Bajo la Luna", type: "Single", status: "Live" },
        { name: "Fuego Nuevo", type: "New single", status: "Delivered" },
        { name: "Horizontes", type: "EP", status: "In review" },
        { name: "Raíces Vol. II", type: "Album", status: "Scheduled" },
      ],
      badgesByItem: [["UPC 8909213", "Royalties: $1,204"], ["Splits 60/40"], ["4 tracks"], ["Releases in 12 days"]],
      statFundLabel: "artist fund",
      statPlatformsLabel: "platforms",
      stats: [
        { id: "platforms", to: 450, suffix: "+", label: "Digital platforms" },
        { id: "delivery", to: 48, prefix: "24-", suffix: "h", label: "Express delivery" },
        { id: "commission", to: 10, suffix: "%", label: "Doble R commission" },
      ],
    },
    communityStats: {
      items: [
        { id: "artists", to: 1, suffix: "K+", label: "Artists" },
        { id: "tracks", to: 50, suffix: "K+", label: "Tracks" },
        { id: "paidout", to: 1, prefix: "$", suffix: "M+", label: "Paid Out" },
        { id: "countries", to: 195, suffix: "+", label: "Countries" },
      ],
    },
    requestStatus: {
      pageTitle: "Check Your Request Status",
      pageSubtitle: "Enter the unique code you received when you submitted your distribution request.",
      inputLabel: "Request code",
      inputPlaceholder: "E.g. 090626SOL-020",
      submitButton: "Check status",
      notFoundError: "We couldn't find a request with that code. Check that it's typed correctly.",
      genericError: "Something went wrong checking your request. Please try again.",
      rateLimitError: "Too many attempts. Please try again in a moment.",
      resultArtistLabel: "Artist / Label",
      resultSubmittedLabel: "Submitted on",
      statusUnderReview: "Under review",
      statusSigned: "Agreement signed",
      signedInfo: "You signed your distribution agreement on",
      underReviewInfo: "Your request is under review. We'll reach out by email if we need anything else.",
      searchAnotherButton: "Check another code",
    },
    marquee: {
      label: "Global distribution",
      title: "Your music on more than 450 global digital platforms",
      disclaimer:
        "All brands, logos and platform names shown are the property of their respective owners and are used for informational purposes only. Distribution availability may vary by territory and platform.",
      more: "+450 more stores",
    },
    platformsCatalog: {
      label: "Featured platforms",
      title: "The stores driving the industry.",
      items: [
        { name: "Spotify", desc: "The world's largest music discovery engine, with editorial playlists and recommendation algorithms.", tag: "Canvas & editorial playlists" },
        { name: "Apple Music", desc: "Lossless and Spatial Audio quality across the entire Apple ecosystem.", tag: "Lossless & Spatial Audio" },
        { name: "YouTube Music", desc: "Monetize your official videos with Content ID, synced to your audio distribution.", tag: "Content ID & monetization" },
        { name: "TikTok", desc: "Turn your song into a viral sound inside the creator sound library.", tag: "Viral sounds" },
        { name: "Amazon Music", desc: "Streaming and digital purchase within the Amazon ecosystem, including Alexa devices.", tag: "Alexa & HD streaming" },
        { name: "Deezer", desc: "Editorial reach across Europe and Latin America with Flow, its recommendation algorithm.", tag: "Flow algorithm" },
      ],
      moreLabel: "And much more",
    },
    smartlink: {
      chooseService: "Choose your preferred music service",
      preRelease: "Upcoming release",
      released: "Out now",
      availableOn: "Available on",
      preSave: "Pre-save",
      preAdd: "Pre-add",
      listenNow: "Listen",
      comingSoon: "Coming soon on this platform",
      poweredBy: "Distributed by",
      notFoundTitle: "This link doesn't exist",
      notFoundSubtitle: "Check the link or go back home.",
      backHome: "Back to home",
      followArtist: "Follow",
      recommended: "Recommended for your device",
      formTitle: "Get updates about this release",
      namePlaceholder: "Your name",
      emailPlaceholder: "Your email",
      formSubmit: "Notify me",
      formSuccess: "Thanks! We'll keep you posted.",
      formError: "Please fill in all fields correctly.",
      privacyNote: "We respect your privacy. We never share your data with third parties.",
      manageModeHint: "Management mode: only you can see this button.",
      refreshLinksButton: "Refresh links",
      refreshingLinks: "Checking for updates...",
      refreshNewLinksFound: "We found new links!",
      refreshNoNewLinks: "No updates yet. Try again on release day.",
      refreshError: "Couldn't refresh. Please try again in a moment.",
      noPlatformsYet: "No platforms available yet for this release. Leave your email and we'll let you know as soon as they're ready →",
    },
    createSmartlink: {
      pageTitle: "Create your Smartlink",
      pageSubtitle: "Generate a pre-save page for your release in seconds. All you need is your music's UPC code.",
      upcLabel: "UPC code",
      upcPlaceholder: "E.g. 024543757917",
      lookupButton: "Look up data",
      lookupFound: "We found your release data.",
      lookupNotFound: "We couldn't find data for that UPC. Fill in the fields manually.",
      lookupError: "Couldn't look up the UPC. Please try again.",
      titleLabel: "Song title",
      artistLabel: "Artist name",
      coverLabel: "Cover art URL",
      releaseDateLabel: "Release date",
      statusLabel: "Status",
      statusPreRelease: "Upcoming release",
      statusReleased: "Out now",
      platformLinksLabel: "Platform links (optional)",
      platformLinksHint: "Add the link if it's already live on that store. You can leave it blank and add it later.",
      socialLinksLabel: "Social media (optional)",
      artistNoteLabel: "Artist note (optional)",
      artistNotePlaceholder: "A personal message or the song lyrics",
      submitButton: "Create my Smartlink",
      submitting: "Creating...",
      rateLimitError: "Too many attempts. Wait a few minutes and try again.",
      genericError: "Couldn't create the smartlink. Check your details and try again.",
      requiredFieldsError: "Fill in the UPC, title, artist and cover art to continue.",
      minPlatformsWarning: "We recommend at least 5 active platforms with a direct link. You currently have {count}. Add more manually for a better fan experience.",
      successTitle: "Your Smartlink is ready!",
      successSubtitle: "Share it with your fans on social media.",
      yourLinkLabel: "Your link",
      copyButton: "Copy",
      copiedLabel: "Copied!",
      viewButton: "View my Smartlink",
      createAnotherButton: "Create another Smartlink",
      manageLinkLabel: "Management link (save it privately)",
      manageLinkHint: "Come back here on release day to automatically look for new links (Spotify, Tidal, etc). Don't share it with your fans.",
      copyManageButton: "Copy",
    },
    globalReach: {
      label: "Global reach",
      title: "Present in more than 195 countries.",
      subtitle: "From the Americas to Asia-Pacific, your music reaches the digital markets that matter most, on the leading platforms of every region.",
      regions: [
        { flag: "🌎", name: "North America", desc: "The world's largest recorded music market, with premium streaming and high-value catalog.", platforms: "Spotify · Apple Music · Amazon Music" },
        { flag: "🌎", name: "Latin America", desc: "Reggaeton, corridos and urban music lead digital consumption in the region.", platforms: "YouTube Music · Spotify · Deezer" },
        { flag: "🌍", name: "Europe", desc: "Strong editorial market, with premium streaming and high catalog value.", platforms: "Spotify · Deezer · Apple Music" },
        { flag: "🌍", name: "Africa & Middle East", desc: "Accelerated growth driven by mobile streaming and social media.", platforms: "Boomplay · Audiomack · Anghami" },
        { flag: "🌏", name: "Asia-Pacific", desc: "Distinct local ecosystems and massive mobile consumption in high-volume markets.", platforms: "LINE Music · KKBOX · YouTube Music" },
      ],
    },
    services: {
      chapterLabel: "Chapter 01 — What we do",
      titleLines: ["Everything your music needs,", "in one place."],
      items: {
        distribucion: { title: "Massive digital distribution", desc: "Deliver your music to more than 450 digital platforms in 24-48 hours." },
        vevo: { title: "Videos on Spotify, Apple Music & more", desc: "Distribute your official music videos to Spotify, Apple Music, TIDAL, Boomplay, XITE, YouTube and VEVO." },
        catalogo: { title: "Centralized catalog management", desc: "All your releases, in one private dashboard." },
        revision: { title: "Professional release review", desc: "A specialized team reviews every delivery before it goes live." },
        metadata: { title: "Complete metadata management", desc: "Credits, genres and languages, properly structured." },
        "upc-isrc": { title: "UPC & ISRC", desc: "Assignment of industry-standard identifiers." },
        "regalias-tiempo-real": { title: "Real-time royalties", desc: "Full control of your revenue by platform and territory." },
        splits: { title: "Decimal-precision splits", desc: "Exact distribution among collaborators, no rounding errors." },
        statements: { title: "Downloadable statements", desc: "Period balances, ready to export." },
        presave: { title: "Built-in pre-save", desc: "Pre-save campaigns ready for your next release." },
        soporte: { title: "Specialized human support", desc: "A real team, for artists and labels, whenever you need it." },
      },
    },
    process: {
      chapterLabel: "Chapter 02 — The process",
      title: "How it works.",
      steps: [
        { number: "01", title: "Create your account", desc: "Sign up as an artist, label or manager in minutes." },
        { number: "02", title: "Upload your release", desc: "3000x3000px JPG cover, WAV/FLAC audio, metadata and splits." },
        { number: "03", title: "Professional review", desc: "Fast approval, UPC/ISRC verification and delivery in 24-48 hrs to +450 stores." },
        { number: "04", title: "Manage your catalog", desc: "Check balances, royalties and downloads from your private panel." },
      ],
    },
    royalty: {
      chapterLabel: "Chapter 03 — Transparency",
      title: "Clear, organized royalties.",
      badgePart1: "10% Doble R Records",
      badgePart2: "90% artist fund",
      paragraph:
        "100% of the fund assigned to your release is distributed among the splits set by the artist or label, with a full history of withdrawals and period balances, always available in your private panel.",
      chartLabel90: "Artist / Label Fund",
      calculatorLabel: "Royalty simulator",
      calculatorRevenueLabel: "Estimated monthly revenue",
      calculatorArtistLabel: "Your share (90%)",
      calculatorDobleRLabel: "Doble R Records (10%)",
      sideCards: [
        { title: "Decimal splits", desc: "Exact distribution among collaborators, no rounding errors." },
        { title: "Withdrawal history", desc: "Check every settled balance, sorted by period." },
        { title: "Period balances", desc: "Downloadable statements ready to export whenever you want." },
      ],
    },
    plans: {
      chapterLabel: "Chapter 04 — Choose your plan",
      title: "A plan for every stage of your career.",
      subtitle: "Start for free or unlock a bigger share for yourself with a monthly or annual subscription.",
      toggleMonthly: "Monthly",
      toggleAnnual: "Annual",
      annualDiscountBadge: "Save ~25%",
      annualSuffix: "/yr",
      ctaButton: "Choose plan",
      mostPopularBadge: "Most chosen",
      forYouLabel: "for you",
      items: [
        {
          name: "Free",
          priceMonthly: "$0",
          priceAnnual: "$0",
          priceSuffix: "/mo",
          artistShare: "90%",
          dobleRShare: "10%",
          desc: "Start distributing with no upfront cost. Doble R Records keeps a commission on your royalties.",
          features: ["Distribution to 450+ platforms", "90% of the fund for you, 10% for Doble R Records", "Express delivery in 24-48 hours", "Royalty & splits dashboard included"],
        },
        {
          name: "Premium",
          priceMonthly: "$9.99",
          priceAnnual: "$89",
          priceSuffix: "/mo",
          artistShare: "95%",
          dobleRShare: "5%",
          desc: "Lower Doble R Records' commission to 5% with a fixed subscription.",
          features: ["Everything in Free", "95% of the fund for you, 5% for Doble R Records", "Priority support", "Faster release review"],
        },
        {
          name: "Premium Plus",
          priceMonthly: "$19.99",
          priceAnnual: "$179",
          priceSuffix: "/mo",
          artistShare: "100%",
          dobleRShare: "0%",
          desc: "Keep 100% of your royalties. No commission, just your fixed subscription.",
          features: ["Everything in Premium", "100% of the fund for you, 0% commission", "Dedicated account manager", "Priority pitching to editorial playlists"],
        },
      ],
      disclaimer: "* Reference pricing, subject to final confirmation before paid plans launch.",
    },
    subscribeDialog: {
      title: "Subscribe to",
      description: "Enter your details to continue to secure payment with Stripe.",
      nameLabel: "Your name",
      namePlaceholder: "Full name",
      emailLabel: "Email",
      emailPlaceholder: "you@email.com",
      submitButton: "Continue to payment",
      loadingText: "Redirecting to Stripe...",
      errorMessage: "Couldn't start the payment. Please try again.",
    },
    paymentSuccess: {
      title: "Payment confirmed!",
      subtitle: "Your subscription is active. Welcome to a bigger royalty share.",
      planLabel: "Plan activated",
      pendingTitle: "Confirming your payment...",
      pendingSubtitle: "This may take a few seconds.",
      errorTitle: "We couldn't confirm the payment",
      errorSubtitle: "If you were charged, contact us and we'll fix it.",
      backHomeButton: "Back to home",
    },
    paymentCancelled: {
      title: "Payment cancelled",
      subtitle: "No charge was made. You can try again anytime.",
      backButton: "View plans again",
    },
    comparison: {
      chapterLabel: "Chapter 05 — Why choose us",
      title: "Compare and decide with facts, not promises.",
      subtitle: "Here's how we stack up against the 10 best-known distributors on the market.",
      ourBadge: "Recommended",
      scrollHint: "Swipe to see the rest",
      rowLabels: {
        commission: "Commission they keep",
        costModel: "Cost model",
        platformReach: "Platforms & digital stores",
        delivery: "Delivery time",
        contentId: "YouTube video (Content ID) and VEVO at no extra cost",
        noLockIn: "Request a takedown or exit anytime",
        spanishFirst: "Spanish-first support & dashboard",
      },
      priceLabels: {
        priceFree: "No entry cost",
        priceAnnual: "Annual subscription",
        pricePerRelease: "Pay per release",
        priceFreemium: "Free or paid plan",
        priceSelective: "Invite-only access",
      },
      cellLabels: {
        varies: "Varies",
        addon: "Paid add-on",
        partial: "Partial",
        yes: "Yes",
        no: "No",
      },
      footnote: "*Some providers charge a fixed annual subscription in addition to (or instead of) commission; always check current terms on each distributor's official site. SoundOn charges nothing upfront and pays 100% royalties in year one, but from month 13 it applies a 10% fee on platforms like Spotify/Apple Music (TikTok/Resso stay at 100%), and switching distributors means losing that preferential rate. Comparison built with public information available in 2026 and subject to change by each provider.",
    },
    paraQuien: {
      label: "Who it's for",
      title: "Built for artists and for labels.",
      tabArtists: "Artists",
      tabLabels: "Labels / Managers",
      captionArtists: "Your music, your control.",
      captionLabels: "Scale your catalog.",
      toolsArtists: [
        "Personal catalog dashboard with real-time status",
        "Pre-save requests for every release",
        "Withdrawals and period balances, always visible",
        "Direct splits with producers and collaborators",
        "Dedicated support for release questions",
      ],
      toolsLabels: [
        "Multi-artist management from a single centralized panel",
        "Consolidated royalty reports by artist and release",
        "Metadata and rights management at scale",
        "Roles and access for managers and representatives",
        "Priority review for large catalogs",
      ],
    },
    security: {
      label: "Security & benefits",
      title: "Bank-grade infrastructure.",
      subtitle:
        "Every submission goes through strict validation and rate limits against abuse, with admin access protected by authentication — your financial and identity data is never exposed.",
      statusLabel: "Active",
      points: [
        { title: "Protected admin access", desc: "The admin panel is only reachable with secure authentication; no artist data is visible without a verified session." },
        { title: "Protected files", desc: "Your music and artwork are stored under restricted access protocols." },
        { title: "SSL encryption", desc: "All communication with the portal travels encrypted end to end." },
        { title: "Restricted banking data", desc: "Financial information is handled under limited, segmented access." },
        { title: "Internal audits", desc: "Periodic security reviews of processes and infrastructure." },
        { title: "Continuous monitoring", desc: "Active 24/7 surveillance over the distribution portal." },
      ],
    },
    faq: {
      label: "Frequently asked questions",
      title: "Everything you need to know.",
      items: [
        { q: "How do I sign up for Doble R Records Distribution?", a: "Fill out the registration form with your name, email, artist or label name, and the type of account you want to request. When you're done, you'll be redirected to the official portal to activate your account." },
        { q: "Do you really distribute to more than 450 platforms?", a: "Yes. Your music and videos reach Spotify, Apple Music, YouTube Music, Amazon Music, TikTok, Deezer, Tidal and more than 450 stores and digital platforms worldwide, subject to territory availability." },
        { q: "What audio formats do you accept?", a: "We accept high-quality WAV or FLAC audio files to guarantee the best possible fidelity on every platform." },
        { q: "What requirements does my cover art need to meet?", a: "Covers must be delivered in JPG format with a minimum resolution of 3000x3000px, with no platform logos or contact information." },
        { q: "How much commission do you charge?", a: "Our commission is 10% of what's generated. The remaining 90% of the fund belongs entirely to the artist or label, with transparent split distribution." },
        { q: "How long does it take for my music to go live?", a: "Once your release is approved, delivery to more than 450 platforms takes place within 24 to 48 hours." },
        { q: "How does my music video distribution work?", a: "We distribute your official music videos to Spotify, Apple Music, TIDAL, Boomplay, XITE, YouTube and VEVO, with the same professional standard used by the majors." },
        { q: "Where do I access my account once registered?", a: "All access, catalog management and royalties are handled from the official portal at distro.doblerrecords.com." },
      ],
    },
    testimonials: {
      label: "Success stories",
      title: "What artists and labels are saying.",
      items: [
        { name: "Barrio Fino", role: "Label", quote: "Doble R Records gave us the clarity and speed we needed. Their royalty reports are 100% transparent, delivery to digital platforms is flawless, and support is direct. They've been the key partner in growing the Barrio Fino catalog with full confidence." },
        { name: "Alto Impacto Records", role: "Label", quote: "Migrating our catalog to Doble R Records changed the game. The speed of ingestion to digital platforms, Content ID support, and on-time payments gave us exactly the backing we needed to scale." },
        { name: "Javier \"Javi\" Morales", role: "Representative", quote: "Finding a distributor that truly responds to artists' needs isn't easy. With Doble R Records we have royalty transparency, fast release turnaround, and flawless technical support. They give us the peace of mind to focus 100% on our roster's career." },
      ],
      ctaText: "Already working with us?",
      ctaButton: "Share your experience",
      formTitle: "Share your experience",
      formDescription: "Your review is published immediately in this section.",
      fieldName: "Name",
      fieldRole: "Role or label/artist",
      fieldQuote: "Your review",
      placeholderName: "Your name",
      placeholderRole: "E.g. Label, Artist, Representative",
      placeholderQuote: "Tell us about your experience with Doble R Records...",
      submitButton: "Publish review",
      submitting: "Publishing...",
      successMessage: "Thanks! Your review is now published.",
      errorMessage: "Couldn't publish your review. Try again.",
      rateLimitMessage: "You've sent too many reviews. Try again later.",
      validationMessage: "Fill in all fields (review must be at least 20 characters).",
      countLabel: "verified testimonials",
    },

    footer: {
      ctaHeading: "Start managing your music professionally.",
      navLabel: "Navigation",
      legalLabel: "Legal center",
      legalLinks: ["Terms & Conditions", "Privacy Policy", "Copyright Notice", "Artificial Streaming Policy"],
      taxFormsLink: "Tax forms (W-9 / W-8BEN)",
      coverArtLink: "AI cover art generator",
      requestStatusLink: "Check request status",
      contactLabel: "Contact",
      tagline: "Global digital distribution for artists, labels and managers. 90% of the fund is always yours.",
      copyright: "Copyright © 2026 Doble R Records. All rights reserved.",
      staticNote: "Static architecture · No exposed databases",
    },
    modal: {
      title: "Distribute your music",
      description: "Fill in your details and we'll take you to the official portal to activate your account.",
      fieldName: "Full name",
      fieldEmail: "Email address",
      fieldPhone: "Phone number",
      fieldLabel: "Artist or Label Name",
      fieldAccountType: "Account type to request",
      fieldCatalogSize: "Your current catalog size",
      fieldReleaseFrequency: "Release frequency",
      fieldExperience: "Prior distribution experience",
      fieldGoals: "Your goals with Doble R Records",
      fieldSocialLinks: "Social media & streaming platform links",
      sectionContact: "Contact information",
      sectionArtist: "Artist or label information",
      sectionCatalog: "Release and catalog details",
      sectionExperience: "Experience and goals",
      sectionLinks: "Links and socials",
      placeholderName: "Your full name",
      placeholderEmail: "you@email.com",
      placeholderPhone: "+1 555 123 4567",
      placeholderLabel: "Your artist name or label",
      placeholderCatalogSize: "E.g. 20 songs, 3 albums",
      placeholderReleaseFrequency: "Select a frequency",
      placeholderExperience: "Briefly tell us your experience distributing music",
      placeholderGoals: "What do you want to achieve with Doble R Records Distribution?",
      placeholderSocialLinks: "Spotify, Apple Music, YouTube, Instagram...",
      placeholderSelect: "Select an option",
      optionArtist: "Artist",
      optionLabel: "Label",
      optionManager: "Manager / Representative",
      releaseFrequencyMonthly: "Monthly",
      releaseFrequencyWeekly: "Weekly",
      releaseFrequencyQuarterly: "Quarterly",
      releaseFrequencyOther: "Other",
      accountTypeError: "Select an account type to continue.",
      releaseFrequencyError: "Select a release frequency to continue.",
      submitButton: "Continue to portal",
      footnote: "By continuing you'll be redirected to distro.doblerrecords.com to securely complete your registration.",
      requestSubmitError: "We couldn't submit your application. Check your details and try again.",
      underReviewTitle: "Application Under Review",
      underReviewSubmittedOn: "Submitted on",
      underReviewMessage: "Thank you for submitting your application! Our team will review your information and contact you via email once a decision has been made.",
      underReviewLockedNote: "This application cannot be modified once submitted.",
      underReviewContinueButton: "Continue to sign the agreement",
      yourCodeLabel: "Your request code",
      yourCodeHint: "Save it to check your request status anytime at /consultar-solicitud",
      copyButton: "Copy",
      copiedLabel: "Copied!",
      successTitle: "Request received!",
      successDesc: "We're redirecting you to the official portal to activate your account…",
      spamNote: "Our team will review your request and reach out if we need anything else. You can now continue to the portal to activate your account.",
      continueButton: "Continue",
      backButton: "Back",
      agreementTitle: "License and Digital Distribution Agreement",
      agreementIntro: "Before continuing, please review and accept the license and digital distribution agreement.",
      keyPointsTitle: "What you should know about our agreement:",
      keyPointOwnership: "**100% Owner of Your Music:** You keep full ownership of your master and composition. We're just a bridge to the stores.",
      keyPointCommission: "**10% Commission:** Transparent scheme. You keep 90% of every royalty you generate; we retain 10% for distribution and tools.",
      keyPointNoLockIn: "**No Forced Terms:** You're free. You can request a takedown of your catalog at any time, no penalties.",
      scrollHint: "Scroll to the end to be able to accept the agreement.",
      checkboxLabel: "I have read and accept the License and Digital Distribution Agreement",
      acceptButton: "Accept distribution agreement",
      sending: "Sending…",
      submitError: "We couldn't process your request. Check your details and try again in a few minutes.",
      rateLimitError: "Too many attempts from this device. Please wait a few minutes before trying again.",
    },
  },
  pt: {
    nav: {
      home: "Início",
      services: "Serviços",
      smartlinks: "Smart Links",
      howItWorks: "Como funciona",
      platforms: "Plataformas",
      royalties: "Royalties",
      plans: "Planos",
      faq: "FAQ",
      contact: "Contato",
      login: "Entrar",
      register: "Distribua sua música",
    },
    floatingWhatsapp: {
      tooltip: "Fale com a gente no WhatsApp",
    },
    cookieConsent: {
      message: "Usamos cookies para melhorar sua experiência e analisar o uso do site.",
      acceptButton: "Aceitar",
      privacyLink: "Política de Privacidade",
    },
    coverArt: {
      pageTitle: "Gerador de Capas com IA",
      pageSubtitle: "Crie uma capa profissional para seu próximo lançamento em segundos. Escolha seu estilo e deixe a IA fazer o resto.",
      fieldGenre: "Gênero / Estilo",
      fieldConcept: "Conceito Visual",
      fieldColors: "Cores Principais",
      placeholderSelect: "Selecione uma opção",
      genre: {
        romantico_sierreno: "Romântico / Sierreño",
        urbano_trap: "Urbano / Trap",
        pop_electronica: "Pop / Eletrônica",
        corridos: "Corridos",
      },
      concept: {
        minimalista: "Minimalista",
        lujo_nocturno: "Luxo / Vida Noturna",
        vintage_acustico: "Vintage / Acústico",
        callejero: "Urbano de Rua",
        futurista: "Futurista",
      },
      colors: {
        oscuros_neon: "Tons escuros / neon",
        calidos_madera: "Tons quentes / madeira",
        blanco_negro: "Preto e branco elegante",
      },
      generateButton: "Gerar capa",
      generating: "Gerando sua capa… isso pode levar até 1 minuto",
      errorToast: "Não foi possível gerar a capa. Tente novamente em alguns minutos.",
      rateLimitToast: "Você atingiu o limite de gerações por hora. Tente novamente mais tarde.",
      resultTitle: "Sua capa está pronta!",
      resolutionNote: "Resolução 3000×3000 px, prontas para enviar ao Spotify, Apple Music e outras lojas digitais.",
      downloadButton: "Baixar capa",
      regenerateButton: "Gerar outra capa",
      disclaimer: "As capas são geradas com inteligência artificial. Verifique se atende às diretrizes da sua loja digital antes de publicar.",
    },
    taxForms: {
      pageTitle: "Formulários fiscais do IRS",
      pageSubtitle: "Preencha, assine e baixe seu W-9, W-8BEN ou W-8BEN-E em minutos, sem complicações.",
      backToForms: "← Escolher outro formulário",
      chooseTitle: "Qual formulário você precisa preencher?",
      privacyNote: "Seus dados são enviados de forma segura à Doble R Records para fins de conformidade fiscal (IRS). Não compartilhamos essas informações com terceiros.",
      forms: {
        w9: {
          title: "W-9",
          subtitle: "Pessoas ou entidades dos EUA",
          useWhen: "Use se você é cidadão/residente dos EUA ou uma entidade dos EUA (inclui SSN ou EIN).",
        },
        w8ben: {
          title: "W-8BEN",
          subtitle: "Indivíduos estrangeiros (fora dos EUA)",
          useWhen: "Use se você é uma pessoa física que NÃO é cidadã nem residente fiscal dos EUA.",
        },
        w8bene: {
          title: "W-8BEN-E",
          subtitle: "Empresas / labels estrangeiras",
          useWhen: "Use se sua label ou empresa foi constituída fora dos Estados Unidos.",
        },
      },
      sections: {
        identification: "Identificação",
        address: "Endereço",
        mailingAddress: "Endereço postal (se diferente, opcional)",
        taxInfo: "Informação fiscal",
        treaty: "Benefícios de tratado fiscal (opcional)",
        certification: "Certificação e assinatura",
      },
      fields: {
        name: "Nome completo (Name)",
        orgName: "Nome da empresa/entidade",
        businessName: "Nome comercial / disregarded entity (opcional)",
        disregardedEntityName: "Nome de disregarded entity (opcional)",
        taxClassification: "Classificação fiscal federal",
        llcTaxClass: "Classificação da LLC (C, S ou P)",
        otherDescription: "Especifique",
        chapter3Status: "Status do Capítulo 3 (tipo de entidade)",
        chapter4Status: "Status FATCA (Capítulo 4)",
        exemptPayeeCode: "Código de beneficiário isento (opcional)",
        fatcaExemptCode: "Código de isenção FATCA (opcional)",
        address: "Endereço (rua e número)",
        cityStateZip: "Cidade, estado e CEP",
        country: "País",
        mailingAddress: "Endereço postal (rua e número)",
        mailingCityStateZip: "Cidade, estado e CEP",
        mailingCountry: "País",
        countryOfCitizenship: "País de cidadania",
        countryOfIncorporation: "País de incorporação",
        accountNumbers: "Número(s) de conta (opcional)",
        ssn: "Número de Seguro Social (SSN)",
        ein: "Número de identificação do empregador (EIN)",
        usTin: "Número de identificação fiscal dos EUA (opcional)",
        foreignTaxId: "Número de identificação fiscal estrangeiro (opcional)",
        ftinNotRequired: "Meu país não exige um número de identificação fiscal (FTIN)",
        referenceNumber: "Número(s) de referência (opcional)",
        dateOfBirth: "Data de nascimento (MM-DD-AAAA)",
        treatyCountry: "País do tratado",
        treatyArticle: "Artigo do tratado",
        treatyParagraph: "Parágrafo",
        treatyIncomeType: "Tipo de renda",
        treatyRate: "Taxa de retenção (%)",
        treatyConditions: "Condições adicionais",
        printName: "Nome de quem assina (Print name of signer)",
        signature: "Assinatura (desenhe com o mouse ou o dedo)",
      },
      taxClassificationOptions: {
        individual: "Indivíduo / proprietário único",
        c_corp: "Corporação C",
        s_corp: "Corporação S",
        partnership: "Sociedade (Partnership)",
        trust_estate: "Trust / estate",
        llc: "LLC",
        other: "Outro",
      },
      chapter3Options: {
        corporation: "Corporação",
        partnership: "Sociedade (Partnership)",
        simple_trust: "Simple trust",
        tax_exempt_organization: "Organização isenta de impostos",
        complex_trust: "Complex trust",
        foreign_gov_controlled_entity: "Entidade controlada por governo estrangeiro",
        central_bank_of_issue: "Banco central emissor",
        private_foundation: "Fundação privada",
        estate: "Estate",
        foreign_gov_integral_part: "Parte integral de governo estrangeiro",
        grantor_trust: "Grantor trust",
        disregarded_entity: "Disregarded entity",
        international_organization: "Organização internacional",
      },
      chapter4Options: {
        active_nffe: "Active NFFE (entidade ativa não financeira)",
        passive_nffe: "Passive NFFE (entidade passiva não financeira)",
        other: "Outro / não tenho certeza (deixe em branco e consulte um assessor fiscal)",
      },
      chapter4Hint: "Se sua classificação FATCA não é Active NFFE nem Passive NFFE, deixe este campo sem selecionar: geraremos o resto do formulário e você completa essa seção com seu assessor fiscal.",
      submitButton: "Gerar e baixar PDF assinado",
      submitting: "Gerando PDF...",
      previewButton: "Visualizar PDF",
      previewing: "Gerando visualização...",
      previewErrorToast: "Não foi possível gerar a visualização. Verifique se os campos obrigatórios estão preenchidos.",
      successToast: "PDF gerado e baixado. Também recebemos uma cópia para o seu arquivo.",
      errorToast: "Não foi possível gerar o PDF. Tente novamente.",
      rateLimitToast: "Muitas tentativas. Espere alguns minutos e tente novamente.",
      requiredField: "Este campo é obrigatório",
      signatureHint: "Desenhe sua assinatura como faria no papel.",
      signatureRequiredToast: "Por favor, desenhe sua assinatura antes de enviar.",
      disclaimer: "Esta ferramenta ajuda você a preencher o formulário oficial do IRS, mas não substitui assessoria legal ou fiscal profissional. Sempre verifique as informações antes de enviar.",
    },
    hero: {
      badge: "+450 plataformas · Entrega 24-48h · Vídeo global multiplataforma",
      titleLines: ["Doble R Records", "Distribution —", "sua música merece", "ir mais longe."],
      subtitle:
        "Gerencie seus lançamentos, catálogo, royalties e distribuição digital em mais de 450 plataformas a partir de uma infraestrutura profissional. Entrega expressa em 24-48 horas e distribuição dos seus videoclipes musicais para Spotify, Apple Music, TIDAL, Boomplay, XITE, YouTube e VEVO.",
      ctaRegister: "Distribua sua música",
      ctaLogin: "Entrar",
      catalogTitle: "Meu catálogo",
      catalogSubtitle: "Painel privado",
      items: [
        { name: "Bajo la Luna", type: "Single", status: "Live" },
        { name: "Fuego Nuevo", type: "Novo single", status: "Entregue" },
        { name: "Horizontes", type: "EP", status: "Em revisão" },
        { name: "Raíces Vol. II", type: "Álbum", status: "Agendado" },
      ],
      badgesByItem: [["UPC 8909213", "Royalties: $1.204"], ["Splits 60/40"], ["4 faixas"], ["Lança em 12 dias"]],
      statFundLabel: "fundo do artista",
      statPlatformsLabel: "plataformas",
      stats: [
        { id: "platforms", to: 450, suffix: "+", label: "Plataformas digitais" },
        { id: "delivery", to: 48, prefix: "24-", suffix: "h", label: "Entrega expressa" },
        { id: "commission", to: 10, suffix: "%", label: "Comissão Doble R" },
      ],
    },
    communityStats: {
      items: [
        { id: "artists", to: 1, suffix: "K+", label: "Artistas" },
        { id: "tracks", to: 50, suffix: "K+", label: "Músicas" },
        { id: "paidout", to: 1, prefix: "$", suffix: "M+", label: "Pago a artistas" },
        { id: "countries", to: 195, suffix: "+", label: "Países" },
      ],
    },
    requestStatus: {
      pageTitle: "Consulte o Status da sua Solicitação",
      pageSubtitle: "Digite o código único que você recebeu ao enviar sua solicitação de distribuição.",
      inputLabel: "Código da solicitação",
      inputPlaceholder: "Ex. 090626SOL-020",
      submitButton: "Consultar",
      notFoundError: "Não encontramos nenhuma solicitação com esse código. Verifique se está escrito corretamente.",
      genericError: "Ocorreu um erro ao consultar sua solicitação. Tente novamente.",
      rateLimitError: "Muitas tentativas. Tente novamente em um momento.",
      resultArtistLabel: "Artista / Selo",
      resultSubmittedLabel: "Enviada em",
      statusUnderReview: "Em análise",
      statusSigned: "Acordo assinado",
      signedInfo: "Você assinou seu acordo de distribuição em",
      underReviewInfo: "Sua solicitação está em análise. Entraremos em contato por e-mail se precisarmos de algo mais.",
      searchAnotherButton: "Consultar outro código",
    },
    marquee: {
      label: "Distribuição global",
      title: "Sua música em mais de 450 plataformas digitais globais",
      disclaimer:
        "Todas as marcas, logotipos e nomes de plataformas exibidos são propriedade de seus respectivos donos e são usados apenas para fins informativos. A disponibilidade de distribuição pode variar por território e plataforma.",
      more: "+450 lojas a mais",
    },
    platformsCatalog: {
      label: "Plataformas em destaque",
      title: "As lojas que movem a indústria.",
      items: [
        { name: "Spotify", desc: "O maior mecanismo de descoberta musical do mundo, com playlists editoriais e algoritmos de recomendação.", tag: "Canvas & playlists editoriais" },
        { name: "Apple Music", desc: "Áudio em qualidade Lossless e Spatial Audio em todo o ecossistema Apple.", tag: "Lossless & Spatial Audio" },
        { name: "YouTube Music", desc: "Monetize seus vídeos oficiais com Content ID, sincronizado com sua distribuição de áudio.", tag: "Content ID & monetização" },
        { name: "TikTok", desc: "Transforme sua música em um som viral dentro da biblioteca de sons para criadores.", tag: "Sons virais" },
        { name: "Amazon Music", desc: "Streaming e compra digital dentro do ecossistema Amazon, incluindo dispositivos Alexa.", tag: "Alexa & streaming HD" },
        { name: "Deezer", desc: "Alcance editorial na Europa e América Latina com o Flow, seu algoritmo de recomendação.", tag: "Algoritmo Flow" },
      ],
      moreLabel: "E muito mais",
    },
    smartlink: {
      chooseService: "Escolha sua plataforma de música preferida",
      preRelease: "Próximo lançamento",
      released: "Já disponível",
      availableOn: "Disponível em",
      preSave: "Pré-salvar",
      preAdd: "Pré-adicionar",
      listenNow: "Ouvir",
      comingSoon: "Em breve nesta plataforma",
      poweredBy: "Distribuído por",
      notFoundTitle: "Este link não existe",
      notFoundSubtitle: "Verifique o link ou volte ao início.",
      backHome: "Voltar ao início",
      followArtist: "Siga",
      recommended: "Recomendado para seu dispositivo",
      formTitle: "Receba novidades deste lançamento",
      namePlaceholder: "Seu nome",
      emailPlaceholder: "Seu e-mail",
      formSubmit: "Quero saber",
      formSuccess: "Obrigado! Vamos te avisar das novidades.",
      formError: "Preencha todos os campos corretamente.",
      privacyNote: "Respeitamos sua privacidade. Não compartilhamos seus dados com terceiros.",
      manageModeHint: "Modo de gestão: somente você pode ver este botão.",
      refreshLinksButton: "Atualizar links",
      refreshingLinks: "Buscando atualizações...",
      refreshNewLinksFound: "Encontramos novos links!",
      refreshNoNewLinks: "Nenhuma novidade por agora. Tente novamente no dia do lançamento.",
      refreshError: "Não foi possível atualizar. Tente novamente em um momento.",
      noPlatformsYet: "Ainda não há plataformas disponíveis para este lançamento. Deixe seu e-mail e avisaremos quando estiverem prontas →",
    },
    createSmartlink: {
      pageTitle: "Crie seu Smartlink",
      pageSubtitle: "Gere uma página de pre-save para seu lançamento em segundos. Você só precisa do código UPC da sua música.",
      upcLabel: "Código UPC",
      upcPlaceholder: "Ex. 024543757917",
      lookupButton: "Buscar dados",
      lookupFound: "Encontramos os dados do seu lançamento.",
      lookupNotFound: "Não encontramos dados para esse UPC. Preencha os campos manualmente.",
      lookupError: "Não foi possível consultar o UPC. Tente novamente.",
      titleLabel: "Título da música",
      artistLabel: "Nome do artista",
      coverLabel: "URL da capa",
      releaseDateLabel: "Data de lançamento",
      statusLabel: "Status",
      statusPreRelease: "Próximo lançamento",
      statusReleased: "Já disponível",
      platformLinksLabel: "Links de plataformas (opcional)",
      platformLinksHint: "Adicione o link se já estiver disponível nessa loja. Você pode deixar em branco e adicionar depois.",
      socialLinksLabel: "Redes sociais (opcional)",
      artistNoteLabel: "Nota do artista (opcional)",
      artistNotePlaceholder: "Uma mensagem pessoal ou a letra da música",
      submitButton: "Criar meu Smartlink",
      submitting: "Criando...",
      rateLimitError: "Muitas tentativas. Espere alguns minutos e tente novamente.",
      genericError: "Não foi possível criar o smartlink. Verifique seus dados e tente novamente.",
      requiredFieldsError: "Preencha o UPC, título, artista e capa para continuar.",
      minPlatformsWarning: "Recomendamos pelo menos 5 plataformas ativas com link direto. Agora você tem {count}. Adicione mais manualmente para uma melhor experiência para seus fãs.",
      successTitle: "Seu Smartlink está pronto!",
      successSubtitle: "Compartilhe com seus fãs nas redes sociais.",
      yourLinkLabel: "Seu link",
      copyButton: "Copiar",
      copiedLabel: "Copiado!",
      viewButton: "Ver meu Smartlink",
      createAnotherButton: "Criar outro Smartlink",
      manageLinkLabel: "Link de gestão (salve em privado)",
      manageLinkHint: "Volte aqui no dia do lançamento para buscar automaticamente novos links (Spotify, Tidal, etc). Não compartilhe com seus fãs.",
      copyManageButton: "Copiar",
    },
    globalReach: {
      label: "Alcance global",
      title: "Presença em mais de 195 países.",
      subtitle: "Das Américas à Ásia-Pacífico, sua música chega aos mercados digitais que mais importam, nas plataformas líderes de cada região.",
      regions: [
        { flag: "🌎", name: "América do Norte", desc: "O maior mercado fonográfico do mundo, com streaming premium e catálogo de alto valor.", platforms: "Spotify · Apple Music · Amazon Music" },
        { flag: "🌎", name: "América Latina", desc: "Reggaeton, corridos e música urbana lideram o consumo digital na região.", platforms: "YouTube Music · Spotify · Deezer" },
        { flag: "🌍", name: "Europa", desc: "Mercado editorial forte, com streaming premium e catálogo de alto valor.", platforms: "Spotify · Deezer · Apple Music" },
        { flag: "🌍", name: "África & Oriente Médio", desc: "Crescimento acelerado impulsionado pelo streaming móvel e redes sociais.", platforms: "Boomplay · Audiomack · Anghami" },
        { flag: "🌏", name: "Ásia-Pacífico", desc: "Ecossistemas próprios e consumo móvel massivo em mercados de altíssimo volume.", platforms: "LINE Music · KKBOX · YouTube Music" },
      ],
    },
    services: {
      chapterLabel: "Capítulo 01 — O que fazemos",
      titleLines: ["Tudo o que sua música precisa,", "em um só lugar."],
      items: {
        distribucion: { title: "Distribuição digital massiva", desc: "Entregue sua música em mais de 450 plataformas digitais em 24-48 horas." },
        vevo: { title: "Vídeos no Spotify, Apple Music e mais", desc: "Distribua seus videoclipes oficiais para Spotify, Apple Music, TIDAL, Boomplay, XITE, YouTube e VEVO." },
        catalogo: { title: "Gestão de catálogo centralizada", desc: "Todos os seus lançamentos, em um só painel privado." },
        revision: { title: "Revisão profissional de lançamentos", desc: "Equipe especializada revisa cada entrega antes de ir ao mercado." },
        metadata: { title: "Administração completa de metadata", desc: "Créditos, gêneros e idiomas corretamente estruturados." },
        "upc-isrc": { title: "UPC e ISRC", desc: "Atribuição de identificadores padrão da indústria." },
        "regalias-tiempo-real": { title: "Royalties em tempo real", desc: "Controle total das suas receitas por plataforma e território." },
        splits: { title: "Splits com precisão decimal", desc: "Divisão exata entre colaboradores, sem erros de arredondamento." },
        statements: { title: "Statements para download", desc: "Balanços por período, prontos para exportar." },
        presave: { title: "Pre-save integrado", desc: "Campanhas de pre-save prontas para seu próximo lançamento." },
        soporte: { title: "Suporte humano especializado", desc: "Uma equipe real, para artistas e labels, sempre que precisar." },
      },
    },
    process: {
      chapterLabel: "Capítulo 02 — O processo",
      title: "Como funciona.",
      steps: [
        { number: "01", title: "Crie sua conta", desc: "Cadastre-se como artista, label ou representante em minutos." },
        { number: "02", title: "Envie seu lançamento", desc: "Capa JPG 3000x3000px, áudios em WAV/FLAC, metadata e splits." },
        { number: "03", title: "Revisão profissional", desc: "Aprovação rápida, verificação de UPC/ISRC e saída em 24-48h para +450 lojas." },
        { number: "04", title: "Gerencie seu catálogo", desc: "Consulte balanços, royalties e downloads a partir do seu painel privado." },
      ],
    },
    royalty: {
      chapterLabel: "Capítulo 03 — Transparência",
      title: "Royalties claros e organizados.",
      badgePart1: "10% Doble R Records",
      badgePart2: "90% fundo do artista",
      paragraph:
        "100% do fundo atribuído ao seu lançamento é dividido entre os splits definidos por artista ou label, com histórico completo de retiradas e balanços por período, sempre disponíveis no seu painel privado.",
      chartLabel90: "Fundo Artista / Label",
      calculatorLabel: "Simulador de royalties",
      calculatorRevenueLabel: "Receita mensal estimada",
      calculatorArtistLabel: "Sua parte (90%)",
      calculatorDobleRLabel: "Doble R Records (10%)",
      sideCards: [
        { title: "Splits decimais", desc: "Divisão exata entre colaboradores, sem erros de arredondamento." },
        { title: "Histórico de retiradas", desc: "Consulte cada balanço liquidado, ordenado por período." },
        { title: "Balanços por período", desc: "Statements para download, prontos para exportar quando quiser." },
      ],
    },
    plans: {
      chapterLabel: "Capítulo 04 — Escolha seu plano",
      title: "Um plano para cada etapa da sua carreira.",
      subtitle: "Comece gratuitamente ou desbloqueie uma porcentagem maior para você com uma assinatura mensal ou anual.",
      toggleMonthly: "Mensal",
      toggleAnnual: "Anual",
      annualDiscountBadge: "Economize ~25%",
      annualSuffix: "/ano",
      ctaButton: "Escolher plano",
      mostPopularBadge: "Mais escolhido",
      forYouLabel: "para você",
      items: [
        {
          name: "Free",
          priceMonthly: "$0",
          priceAnnual: "$0",
          priceSuffix: "/mês",
          artistShare: "90%",
          dobleRShare: "10%",
          desc: "Comece a distribuir sem custo inicial. A Doble R Records retém uma comissão sobre seus royalties.",
          features: ["Distribuição para mais de 450 plataformas", "90% do fundo para você, 10% para a Doble R Records", "Entrega expressa em 24-48 horas", "Painel de royalties e splits incluído"],
        },
        {
          name: "Premium",
          priceMonthly: "$9.99",
          priceAnnual: "$89",
          priceSuffix: "/mês",
          artistShare: "95%",
          dobleRShare: "5%",
          desc: "Reduza a comissão da Doble R Records para 5% com uma assinatura fixa.",
          features: ["Tudo do Free", "95% do fundo para você, 5% para a Doble R Records", "Suporte prioritário", "Revisão acelerada de lançamentos"],
        },
        {
          name: "Premium Plus",
          priceMonthly: "$19.99",
          priceAnnual: "$179",
          priceSuffix: "/mês",
          artistShare: "100%",
          dobleRShare: "0%",
          desc: "Fique com 100% dos seus royalties. Sem comissão, apenas sua assinatura fixa.",
          features: ["Tudo do Premium", "100% do fundo para você, 0% de comissão", "Gerente de conta dedicado", "Pitch prioritário para playlists editoriais"],
        },
      ],
      disclaimer: "* Preços de referência, sujeitos a confirmação final antes do lançamento dos planos pagos.",
    },
    subscribeDialog: {
      title: "Assine o",
      description: "Insira seus dados para continuar ao pagamento seguro com Stripe.",
      nameLabel: "Seu nome",
      namePlaceholder: "Nome completo",
      emailLabel: "E-mail",
      emailPlaceholder: "voce@email.com",
      submitButton: "Continuar para pagamento",
      loadingText: "Redirecionando para o Stripe...",
      errorMessage: "Não foi possível iniciar o pagamento. Tente novamente.",
    },
    paymentSuccess: {
      title: "Pagamento confirmado!",
      subtitle: "Sua assinatura está ativa. Bem-vindo a uma porcentagem maior de royalties.",
      planLabel: "Plano ativado",
      pendingTitle: "Confirmando seu pagamento...",
      pendingSubtitle: "Isso pode levar alguns segundos.",
      errorTitle: "Não conseguimos confirmar o pagamento",
      errorSubtitle: "Se você foi cobrado, contate-nos e resolveremos.",
      backHomeButton: "Voltar ao início",
    },
    paymentCancelled: {
      title: "Pagamento cancelado",
      subtitle: "Nenhuma cobrança foi feita. Você pode tentar novamente quando quiser.",
      backButton: "Ver planos novamente",
    },
    comparison: {
      chapterLabel: "Capítulo 05 — Por que nos escolher",
      title: "Compare e decida com dados, não com promessas.",
      subtitle: "Veja como nos comparamos com as 10 distribuidoras mais conhecidas do mercado.",
      ourBadge: "Recomendado",
      scrollHint: "Deslize para ver os demais",
      rowLabels: {
        commission: "Comissão retida",
        costModel: "Modelo de custo",
        platformReach: "Plataformas e lojas digitais",
        delivery: "Tempo de entrega",
        contentId: "Vídeo no YouTube (Content ID) e VEVO sem custo extra",
        noLockIn: "Solicite sua baixa ou takedown quando quiser",
        spanishFirst: "Suporte e painel em espanhol",
      },
      priceLabels: {
        priceFree: "Sem custo de entrada",
        priceAnnual: "Assinatura anual",
        pricePerRelease: "Pagamento por lançamento",
        priceFreemium: "Grátis ou plano pago",
        priceSelective: "Acesso por convite",
      },
      cellLabels: {
        varies: "Variável",
        addon: "Extra pago",
        partial: "Parcial",
        yes: "Sim",
        no: "Não",
      },
      footnote: "*Alguns provedores cobram assinatura anual fixa além de (ou em vez de) comissão; sempre confira os termos vigentes no site oficial de cada distribuidora. A SoundOn não cobra nada no início e paga 100% das royalties no primeiro ano, mas a partir do mês 13 aplica 10% em plataformas como Spotify/Apple Music (TikTok/Resso permanecem em 100%), e trocar de distribuidora significa perder essa taxa preferencial. Comparativo elaborado com informações públicas disponíveis em 2026 e sujeito a alterações por cada provedor.",
    },
    paraQuien: {
      label: "Para quem",
      title: "Feito para artistas e para labels.",
      tabArtists: "Artistas",
      tabLabels: "Labels / Representantes",
      captionArtists: "Sua música, seu controle.",
      captionLabels: "Escale seu catálogo.",
      toolsArtists: [
        "Painel de catálogo pessoal com status em tempo real",
        "Solicitações de Pre-save para cada lançamento",
        "Retiradas e balanços por período, sempre visíveis",
        "Splits diretos com produtores e colaboradores",
        "Suporte dedicado para dúvidas de lançamento",
      ],
      toolsLabels: [
        "Gestão multi-artista a partir de um só painel centralizado",
        "Relatórios consolidados de royalties por artista e release",
        "Administração de metadata e direitos em escala",
        "Perfis e acessos para managers e representantes",
        "Prioridade de revisão para catálogos grandes",
      ],
    },
    security: {
      label: "Segurança e benefícios",
      title: "Infraestrutura de nível bancário.",
      subtitle:
        "Cada envio passa por validações estritas e limites de taxa contra abuso, com acesso administrativo protegido por autenticação — seus dados financeiros e de identidade nunca ficam expostos.",
      statusLabel: "Ativo",
      points: [
        { title: "Acesso administrativo protegido", desc: "O painel de administração só é acessível com autenticação segura; nenhum dado de artistas é visível sem sessão verificada." },
        { title: "Arquivos protegidos", desc: "Sua música e capas são armazenadas sob protocolos de acesso restrito." },
        { title: "Criptografia SSL", desc: "Toda a comunicação com o portal viaja criptografada de ponta a ponta." },
        { title: "Dados bancários restritos", desc: "As informações financeiras são tratadas com acesso limitado e segmentado." },
        { title: "Auditoria interna", desc: "Revisões periódicas de segurança sobre processos e infraestrutura." },
        { title: "Monitoramento contínuo", desc: "Vigilância ativa 24/7 sobre o portal de distribuição." },
      ],
    },
    faq: {
      label: "Perguntas frequentes",
      title: "Tudo o que você precisa saber.",
      items: [
        { q: "Como faço para me cadastrar na Doble R Records Distribution?", a: "Preencha o formulário de cadastro com seu nome, e-mail, nome de artista ou label e o tipo de conta que deseja solicitar. Ao finalizar, você será direcionado ao portal oficial para ativar sua conta." },
        { q: "Vocês realmente distribuem para mais de 450 plataformas?", a: "Sim. Sua música e vídeos chegam ao Spotify, Apple Music, YouTube Music, Amazon Music, TikTok, Deezer, Tidal e mais de 450 lojas e plataformas digitais no mundo todo, sujeito à disponibilidade por território." },
        { q: "Quais formatos de áudio vocês aceitam?", a: "Aceitamos arquivos de áudio em alta qualidade WAV ou FLAC para garantir a melhor fidelidade possível em cada plataforma." },
        { q: "Quais requisitos minha capa deve cumprir?", a: "As capas devem ser entregues em formato JPG com resolução mínima de 3000x3000px, sem logos de plataformas nem informações de contato." },
        { q: "Quanto vocês cobram de comissão?", a: "Nossa comissão é de 10% sobre o gerado. Os 90% restantes do fundo pertencem integralmente ao artista ou label, com divisão de splits transparente." },
        { q: "Quanto tempo demora para minha música ser lançada?", a: "Depois que seu lançamento for aprovado, a entrega para mais de 450 plataformas ocorre em um período de 24 a 48 horas." },
        { q: "Como funciona a distribuição dos meus videoclipes musicais?", a: "Distribuímos seus videoclipes oficiais para Spotify, Apple Music, TIDAL, Boomplay, XITE, YouTube e VEVO, com o mesmo padrão profissional usado pelas majors." },
        { q: "Onde acesso minha conta depois de me cadastrar?", a: "Todo o acesso, gestão de catálogo e royalties é feito a partir do portal oficial em distro.doblerrecords.com." },
      ],
    },
    testimonials: {
      label: "Casos de sucesso",
      title: "O que artistas e labels estão dizendo.",
      items: [
        { name: "Barrio Fino", role: "Label", quote: "A Doble R Records nos deu a clareza e a velocidade que precisávamos. Seus relatórios de royalties são 100% transparentes, a entrega às plataformas digitais é impecável e o suporte é direto. Tem sido o parceiro-chave para fazer crescer o catálogo da Barrio Fino com total confiança." },
        { name: "Alto Impacto Records", role: "Label", quote: "Migrar nosso catálogo para a Doble R Records mudou o jogo. A velocidade de ingestão nas plataformas digitais, o suporte com o Content ID e a pontualidade nos pagamentos nos deram exatamente o respaldo que precisávamos para escalar." },
        { name: "Javier \"Javi\" Morales", role: "Representante", quote: "Encontrar uma distribuidora que realmente responda às necessidades dos artistas não é fácil. Com a Doble R Records temos transparência em royalties, rapidez nos lançamentos e um suporte técnico impecável. Isso nos dá a tranquilidade para focar 100% na carreira do nosso roster." },
      ],
      ctaText: "Já trabalha com a gente?",
      ctaButton: "Compartilhe sua experiência",
      formTitle: "Compartilhe sua experiência",
      formDescription: "Sua opinião é publicada imediatamente nesta seção.",
      fieldName: "Nome",
      fieldRole: "Cargo ou label/artista",
      fieldQuote: "Sua opinião",
      placeholderName: "Seu nome",
      placeholderRole: "Ex. Label, Artista, Representante",
      placeholderQuote: "Conte sua experiência com a Doble R Records...",
      submitButton: "Publicar opinião",
      submitting: "Publicando...",
      successMessage: "Obrigado! Sua opinião já está publicada.",
      errorMessage: "Não foi possível publicar sua opinião. Tente de novo.",
      rateLimitMessage: "Você enviou muitas opiniões. Tente mais tarde.",
      validationMessage: "Preencha todos os campos (opinião com no mínimo 20 caracteres).",
      countLabel: "depoimentos verificados",
    },

    footer: {
      ctaHeading: "Comece a gerenciar sua música profissionalmente.",
      navLabel: "Navegação",
      legalLabel: "Central legal",
      legalLinks: ["Termos e Condições", "Política de Privacidade", "Aviso de Copyright", "Política de Streaming Artificial"],
      taxFormsLink: "Formulários fiscais (W-9 / W-8BEN)",
      coverArtLink: "Gerador de capas (IA)",
      requestStatusLink: "Consultar status da solicitação",
      contactLabel: "Contato",
      tagline: "Distribuição digital global para artistas, labels e representantes. 90% do fundo é sempre seu.",
      copyright: "Copyright © 2026 Doble R Records. Todos os direitos reservados.",
      staticNote: "Arquitetura estática · Sem bancos de dados expostos",
    },
    modal: {
      title: "Distribua sua música",
      description: "Preencha seus dados e vamos te direcionar ao portal oficial para ativar sua conta.",
      fieldName: "Nome completo",
      fieldEmail: "E-mail",
      fieldPhone: "Número de telefone",
      fieldLabel: "Nome do Artista ou Selo",
      fieldAccountType: "Tipo de conta a solicitar",
      fieldCatalogSize: "Tamanho do seu catálogo atual",
      fieldReleaseFrequency: "Frequência de lançamentos",
      fieldExperience: "Experiência anterior em distribuição",
      fieldGoals: "Seus objetivos com a Doble R Records",
      fieldSocialLinks: "Links de redes sociais e plataformas de streaming",
      sectionContact: "Informações de contato",
      sectionArtist: "Informações do artista ou selo",
      sectionCatalog: "Dados de lançamento e catálogo",
      sectionExperience: "Experiência e objetivos",
      sectionLinks: "Links e redes",
      placeholderName: "Seu nome completo",
      placeholderEmail: "voce@email.com",
      placeholderPhone: "+55 11 91234 5678",
      placeholderLabel: "Seu nome artístico ou label",
      placeholderCatalogSize: "Ex. 20 músicas, 3 álbuns",
      placeholderReleaseFrequency: "Selecione uma frequência",
      placeholderExperience: "Conte brevemente sua experiência distribuindo música",
      placeholderGoals: "O que você quer alcançar com a Doble R Records Distribution?",
      placeholderSocialLinks: "Spotify, Apple Music, YouTube, Instagram...",
      placeholderSelect: "Selecione uma opção",
      optionArtist: "Artista",
      optionLabel: "Label",
      optionManager: "Representante / Manager",
      releaseFrequencyMonthly: "Mensal",
      releaseFrequencyWeekly: "Semanal",
      releaseFrequencyQuarterly: "Trimestral",
      releaseFrequencyOther: "Outra",
      accountTypeError: "Selecione um tipo de conta para continuar.",
      releaseFrequencyError: "Selecione uma frequência de lançamentos para continuar.",
      submitButton: "Continuar para o portal",
      footnote: "Ao continuar você será redirecionado para distro.doblerrecords.com para completar seu cadastro com segurança.",
      requestSubmitError: "Não foi possível enviar sua solicitação. Verifique seus dados e tente novamente.",
      underReviewTitle: "Solicitação em análise",
      underReviewSubmittedOn: "Enviado em",
      underReviewMessage: "Obrigado por enviar sua solicitação! Nossa equipe vai revisar suas informações e entrará em contato por e-mail assim que uma decisão for tomada.",
      underReviewLockedNote: "Esta solicitação não pode ser modificada após o envio.",
      underReviewContinueButton: "Continuar e assinar o acordo",
      yourCodeLabel: "Seu código de solicitação",
      yourCodeHint: "Guarde-o para consultar o status da sua solicitação a qualquer momento em /consultar-solicitud",
      copyButton: "Copiar",
      copiedLabel: "Copiado!",
      successTitle: "Solicitação recebida!",
      successDesc: "Estamos te redirecionando para o portal oficial para ativar sua conta…",
      spamNote: "Nossa equipe vai revisar sua solicitação e entrará em contato se precisar de algo mais. Você já pode continuar para o portal para ativar sua conta.",
      continueButton: "Continuar",
      backButton: "Voltar",
      agreementTitle: "Acordo de Licença e Distribuição Digital",
      agreementIntro: "Antes de continuar, revise e aceite o acordo de licença e distribuição digital.",
      keyPointsTitle: "O que você deve saber sobre nosso acordo:",
      keyPointOwnership: "**100% Dono da Sua Música:** Você mantém total propriedade do seu master e composição. Somos apenas uma ponte para as lojas.",
      keyPointCommission: "**Comissão de 10%:** Esquema transparente. Você mantém 90% de todas as royalties geradas; retemos 10% pela distribuição e ferramentas.",
      keyPointNoLockIn: "**Sem Prazos Forçados:** Você é livre. Pode solicitar a remoção (takedown) do seu catálogo a qualquer momento, sem penalidades.",
      scrollHint: "Role até o final para poder aceitar o acordo.",
      checkboxLabel: "Li e aceito o Acordo de Licença e Distribuição Digital",
      acceptButton: "Aceitar acordo de distribuição",
      sending: "Enviando…",
      submitError: "Não foi possível processar sua solicitação. Verifique seus dados e tente novamente em alguns minutos.",
      rateLimitError: "Muitas tentativas neste dispositivo. Aguarde alguns minutos antes de tentar novamente.",
    },
  },
};
